import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  JSONObject: any;
  Time: any;
  UUID: any;
  Upload: any;
  Void: any;
};

export type AcademicSession = {
  __typename?: 'AcademicSession';
  id: Scalars['Int'];
  externalId?: Maybe<ExternalId>;
  sourceKindId?: Maybe<Scalars['Int']>;
  sourceKind?: Maybe<Scalars['String']>;
  sisId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  dateTermStart: Scalars['DateTime'];
  dateTermEnd: Scalars['DateTime'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  status: AcademicSessionStatus;
  active: Scalars['Boolean'];
  default: Scalars['Boolean'];
};

export type AcademicSessionCreateInput = {
  externalId?: Maybe<ExternalIdInput>;
  sisId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId: Scalars['Int'];
  dateTermStart: Scalars['DateTime'];
  dateTermEnd: Scalars['DateTime'];
  sourceKind?: Maybe<SourceKind>;
};

export enum AcademicSessionOrderField {
  ID = 'ID',
  NAME = 'NAME',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID',
  ORGANIZATION_ID = 'ORGANIZATION_ID',
}

export enum AcademicSessionStatus {
  PREVIOUS = 'PREVIOUS',
  CURRENT = 'CURRENT',
  FUTURE = 'FUTURE',
}

export type AcademicSessionUpdateInput = {
  externalId?: Maybe<ExternalIdUpdateInput>;
  sisId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  sourceKindId?: Maybe<Scalars['Int']>;
  sourceKind?: Maybe<SourceKind>;
  dateTermStart?: Maybe<Scalars['DateTime']>;
  dateTermEnd?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type AcademicSessionWhereInput = {
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<ExternalIdInput>;
};

export type AcademicSessionsDateRangeInput = {
  dateStart: Scalars['DateTime'];
  dateEnd: Scalars['DateTime'];
};

export type AcademicSessionsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<AcademicSessionOrderField>;
};

export type AcademicSessionsUpdateInput = {
  dateTermStart?: Maybe<Scalars['DateTime']>;
  dateTermEnd?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type AcademicSessionsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  sourceId?: Maybe<Array<Scalars['String']>>;
  sourceKind?: Maybe<Array<SourceKind>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  status?: Maybe<AcademicSessionStatus>;
  dateTermRange?: Maybe<AcademicSessionsDateRangeInput>;
  active?: Maybe<Scalars['Boolean']>;
  default?: Maybe<Scalars['Boolean']>;
  AND?: Maybe<Array<AcademicSessionsWhereInput>>;
  OR?: Maybe<Array<AcademicSessionsWhereInput>>;
};

export type AccessActivityEventCreateInput = {
  timestamp: Scalars['DateTime'];
  bookCode: Scalars['String'];
  activityType: Scalars['String'];
  character: CharacterInput;
};

export type AccessActivityPageEventCreateInput = {
  timestamp: Scalars['DateTime'];
  bookId: Scalars['Int'];
  bookCode: Scalars['String'];
  activityType: Scalars['String'];
  pageId: Scalars['Int'];
  pageNumber: Scalars['String'];
  pageLayout: PageLayout;
  section: ApplicationSection;
  character: CharacterInput;
};

export type AccessLinkEventCreateInput = {
  timestamp: Scalars['DateTime'];
  link: Scalars['String'];
  route: RouteSource;
};

export type AccessResourceEventCreateInput = {
  timestamp: Scalars['DateTime'];
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
  resourceTitle: Scalars['String'];
  section: ApplicationSection;
  character: CharacterInput;
};

export type Activity = IActivity & {
  __typename?: 'Activity';
  id: Scalars['Int'];
  activityTypeId: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  bookId: Scalars['Int'];
  book?: Maybe<Book>;
  activityType?: Maybe<ActivityType>;
};

export type ActivityAsset = {
  __typename?: 'ActivityAsset';
  id: Scalars['Int'];
  token: Scalars['String'];
  activityId: Scalars['Int'];
  assetId: Scalars['Int'];
  activity?: Maybe<Activity>;
  asset?: Maybe<Asset>;
};

export type ActivityType = {
  __typename?: 'ActivityType';
  id: Scalars['Int'];
  name: Scalars['String'];
  description: Scalars['String'];
  required: Scalars['Boolean'];
};

export enum ActivityTypeId {
  READ_ALOUD = 'READ_ALOUD',
  READ_STORY = 'READ_STORY',
  SOUND_OUT_WORDS = 'SOUND_OUT_WORDS',
  FIND_THE_LETTER = 'FIND_THE_LETTER',
  FIND_THE_OBJECTS = 'FIND_THE_OBJECTS',
  GUESS_WHO = 'GUESS_WHO',
  GUESS_WHERE = 'GUESS_WHERE',
  GUESS_THE_ORDER = 'GUESS_THE_ORDER',
  FEELINGS_MATCH = 'FEELINGS_MATCH',
  MATCH_IT_TRASH_IT = 'MATCH_IT_TRASH_IT',
  STARTING_SOUND = 'STARTING_SOUND',
  PRACTICE_BOOK = 'PRACTICE_BOOK',
  WET_DRY_TRY = 'WET_DRY_TRY',
}

export enum ActivityTypeName {
  READ_ALOUD = 'READ_ALOUD',
  READ_STORY = 'READ_STORY',
  SOUND_OUT_WORDS = 'SOUND_OUT_WORDS',
  FIND_THE_LETTER = 'FIND_THE_LETTER',
  FIND_THE_OBJECTS = 'FIND_THE_OBJECTS',
  GUESS_WHO = 'GUESS_WHO',
  GUESS_WHERE = 'GUESS_WHERE',
  GUESS_THE_ORDER = 'GUESS_THE_ORDER',
  FEELINGS_MATCH = 'FEELINGS_MATCH',
  MATCH_IT_TRASH_IT = 'MATCH_IT_TRASH_IT',
  STARTING_SOUND = 'STARTING_SOUND',
  PRACTICE_BOOK = 'PRACTICE_BOOK',
  WET_DRY_TRY = 'WET_DRY_TRY',
}

export type ActivityWhereInput = {
  id?: Maybe<Scalars['Int']>;
  book?: Maybe<BookWhereInput>;
};

export type AffirmationsWhereInput = {
  id?: Maybe<Array<Maybe<Scalars['Int']>>>;
  count?: Maybe<Scalars['Int']>;
  randomize?: Maybe<Scalars['Boolean']>;
};

export type App = {
  __typename?: 'App';
  id: Scalars['Int'];
  name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  products: Array<Product>;
  appProducts: Array<AppProduct>;
  pliManaged: Scalars['Boolean'];
  type?: Maybe<ProductType>;
  accessDetails?: Maybe<AppAccessDetails>;
  purchaseDetails?: Maybe<AppPurchaseDetails>;
};

export type AppAccessDetails = {
  __typename?: 'AppAccessDetails';
  bannerUrl: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  iosUrl?: Maybe<Scalars['String']>;
};

export type AppProduct = {
  __typename?: 'AppProduct';
  id: Scalars['Int'];
  appId: Scalars['Int'];
  productId: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  app?: Maybe<App>;
  product?: Maybe<Product>;
  pliManaged: Scalars['Boolean'];
  accessDetails?: Maybe<AppAccessDetails>;
  purchaseDetails?: Maybe<AppPurchaseDetails>;
};

export type AppPurchaseDetails = {
  __typename?: 'AppPurchaseDetails';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  salesQuoteUrl?: Maybe<Scalars['String']>;
  webstoreUrl?: Maybe<Scalars['String']>;
};

export enum ApplicationSection {
  LETTER_BOOKS = 'LETTER_BOOKS',
  LETTER_LEARNING = 'LETTER_LEARNING',
  PRACTICE_BOOKS = 'PRACTICE_BOOKS',
  RESOURCES = 'RESOURCES',
}

export type Asset = IAsset & {
  __typename?: 'Asset';
  id: Scalars['Int'];
  type: AssetType;
  src: Scalars['String'];
  vtt?: Maybe<Scalars['String']>;
  captions?: Maybe<Scalars['JSON']>;
  narrationSrc?: Maybe<Scalars['String']>;
  narrationVtt?: Maybe<Scalars['String']>;
  narrationCaptions?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
};

export enum AssetType {
  AUDIO = 'AUDIO',
  IMAGE = 'IMAGE',
  PDF = 'PDF',
  SVG = 'SVG',
  VIDEO = 'VIDEO',
}

export type AssignAvailableLicenseInput = {
  replaceExistingProductFamilyLicense?: Maybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: Maybe<Scalars['Boolean']>;
  skipManualAssignment?: Maybe<Scalars['Boolean']>;
  studentId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  productCurriculum?: Maybe<ProductIdentifierInput>;
  updates?: Maybe<LicenseAssignmentUpdateInput>;
};

export type AssignAvailableLicenseWhereInput = {
  expiresAfter?: Maybe<Scalars['DateTime']>;
  ignoreLicenseOverage?: Maybe<Scalars['Boolean']>;
  gradeLevel?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  product?: Maybe<ProductIdentifierInput>;
  productFamily?: Maybe<ProductIdentifierInput>;
};

export enum AssigneeType {
  STUDENT = 'STUDENT',
  USER = 'USER',
}

export type Assignment = {
  __typename?: 'Assignment';
  id: Scalars['Int'];
  classroomId: Scalars['Int'];
  characterId: Scalars['Int'];
  title: Scalars['String'];
  dateAssigned: Scalars['DateTime'];
  locale: Locale;
  status?: Maybe<AssignmentStatus>;
  dateStarted?: Maybe<Scalars['DateTime']>;
  dateCompleted?: Maybe<Scalars['DateTime']>;
  classroom: Classroom;
  character: Character;
  activities: Array<Activity>;
  assignmentActivities: Array<AssignmentActivity>;
};

export type AssignmentActivity = {
  __typename?: 'AssignmentActivity';
  id: Scalars['Int'];
  assignmentId: Scalars['Int'];
  activityId: Scalars['Int'];
  assignment: Assignment;
  activity: Activity;
  attempts?: Maybe<Array<Attempt>>;
};

export type AssignmentList = {
  __typename?: 'AssignmentList';
  instructions: AssignmentListInstructions;
  assignments: Array<Maybe<Assignment>>;
};

export type AssignmentListInstructions = {
  __typename?: 'AssignmentListInstructions';
  assignmentSelection: Asset;
  activitySelection: Asset;
};

export type AssignmentListOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<AssignmentOrderField>;
};

export type AssignmentListWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  character?: Maybe<CharactersWhereInput>;
};

export enum AssignmentOrderField {
  ID = 'ID',
}

export enum AssignmentStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  SKIPPED = 'SKIPPED',
}

export type AssignmentWhereInput = {
  id?: Maybe<Scalars['Int']>;
  character?: Maybe<CharacterWhereInput>;
};

export type Attempt = {
  __typename?: 'Attempt';
  id: Scalars['Int'];
  assignmentActivityId: Scalars['Int'];
  studentId: Scalars['Int'];
  status: AttemptStatus;
  dateStarted?: Maybe<Scalars['DateTime']>;
  dateCompleted?: Maybe<Scalars['DateTime']>;
  assignmentActivity: AssignmentActivity;
  files?: Maybe<Array<FileUpload>>;
  studentReward?: Maybe<StudentReward>;
};

export enum AttemptStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  SKIPPED = 'SKIPPED',
}

export enum AuthenticationSource {
  CLASS_LINK = 'CLASS_LINK',
  CLEVER = 'CLEVER',
  GOOGLE = 'GOOGLE',
  LOGIN_APP = 'LOGIN_APP',
  LWT = 'LWT',
  SAML = 'SAML',
}

export type BaseSettingCreateInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export type BatchMutationResult = {
  __typename?: 'BatchMutationResult';
  count?: Maybe<Scalars['Int']>;
};

export type Book = {
  __typename?: 'Book';
  id: Scalars['Int'];
  type: BookType;
  title: Scalars['String'];
  gradeLevel: GradeLevel;
  bookCode: Scalars['String'];
  edition: Scalars['Int'];
  orientation: Orientation;
  path: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  totalPages: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
  locale: Locale;
  pages?: Maybe<Array<Page>>;
  bookProducts: Array<BookProduct>;
  characters?: Maybe<Array<Character>>;
};

export type BookPagesArgs = {
  where?: Maybe<PagesWhereInput>;
  orderBy?: Maybe<PagesOrderInput>;
};

export type BookContent = {
  __typename?: 'BookContent';
  id: Scalars['Int'];
  pageNumber: Scalars['Int'];
  value: Scalars['String'];
};

export type BookList = {
  __typename?: 'BookList';
  instructions: Asset;
  books: Array<Maybe<Book>>;
};

export type BookListOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<BookOrderField>;
};

export type BookListWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  type?: Maybe<Array<BookType>>;
  bookCode?: Maybe<Array<Scalars['String']>>;
  edition?: Maybe<Scalars['Int']>;
  gradeLevel?: Maybe<Array<Scalars['String']>>;
  character?: Maybe<CharactersWhereInput>;
};

export enum BookOrderField {
  ID = 'ID',
  TYPE = 'TYPE',
  TITLE = 'TITLE',
}

export type BookProduct = {
  __typename?: 'BookProduct';
  id: Scalars['Int'];
  bookId: Scalars['Int'];
  productId: Scalars['Int'];
  book: Book;
  product: Product;
};

export enum BookType {
  TEACHERS_GUIDE = 'TEACHERS_GUIDE',
  LETTER_BOOK = 'LETTER_BOOK',
  PRACTICE_BOOK = 'PRACTICE_BOOK',
  CLASSROOM_BOOK = 'CLASSROOM_BOOK',
}

export type BookWhereInput = {
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<BookType>;
  bookCode?: Maybe<Scalars['String']>;
  edition?: Maybe<Scalars['Int']>;
  gradeLevel?: Maybe<Scalars['String']>;
  character?: Maybe<CharacterWhereInput>;
};

export type BulkAssignAvailableLicenseInput = {
  expiresAfter?: Maybe<Scalars['DateTime']>;
  gradeLevel?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  product?: Maybe<ProductIdentifierInput>;
  productCurriculum?: Maybe<ProductIdentifierInput>;
  productFamily?: Maybe<ProductIdentifierInput>;
  ignoreLicenseOverage?: Maybe<Scalars['Boolean']>;
  replaceExistingProductFamilyLicense?: Maybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: Maybe<Scalars['Boolean']>;
  skipManualAssignment?: Maybe<Scalars['Boolean']>;
  studentId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  updates?: Maybe<LicenseAssignmentUpdateInput>;
};

export type BulkAssignAvailableWhereInput = {
  expiresAfter?: Maybe<Scalars['DateTime']>;
  ignoreLicenseOverage?: Maybe<Scalars['Boolean']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
};

export type BulkAssignResult = {
  __typename?: 'BulkAssignResult';
  request: LicenseAssignRequest;
  license?: Maybe<License>;
  error?: Maybe<Scalars['String']>;
};

export type BulkGroupEnrollmentActionGroupCategoryRequest = {
  __typename?: 'BulkGroupEnrollmentActionGroupCategoryRequest';
  classroomId: Scalars['Int'];
  name: Scalars['String'];
};

export type BulkGroupEnrollmentActionGroupRequest = {
  __typename?: 'BulkGroupEnrollmentActionGroupRequest';
  classroomId: Scalars['Int'];
  groupCategory?: Maybe<BulkGroupEnrollmentActionGroupCategoryRequest>;
  name: Scalars['String'];
};

export type BulkGroupEnrollmentActionInput = {
  action: GroupEnrollmentAction;
  studentId: Scalars['Int'];
  groupId?: Maybe<Scalars['Int']>;
  group?: Maybe<GroupEnrollmentGroupInput>;
};

export type BulkGroupEnrollmentActionRequest = {
  __typename?: 'BulkGroupEnrollmentActionRequest';
  studentId: Scalars['Int'];
  groupId?: Maybe<Scalars['Int']>;
  group?: Maybe<BulkGroupEnrollmentActionGroupRequest>;
};

export type BulkGroupEnrollmentActionResult = {
  __typename?: 'BulkGroupEnrollmentActionResult';
  request: BulkGroupEnrollmentActionRequest;
  groupEnrollment?: Maybe<GroupEnrollment>;
  error?: Maybe<Scalars['String']>;
};

export type BulkLicenseActionInput = {
  action: LicenseAction;
  expiresAfter?: Maybe<Scalars['DateTime']>;
  gradeLevel?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  product?: Maybe<ProductIdentifierInput>;
  productCurriculum?: Maybe<ProductIdentifierInput>;
  productFamily?: Maybe<ProductIdentifierInput>;
  ignoreLicenseOverage?: Maybe<Scalars['Boolean']>;
  replaceExistingProductFamilyLicense?: Maybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: Maybe<Scalars['Boolean']>;
  skipManualAssignment?: Maybe<Scalars['Boolean']>;
  studentId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  updates?: Maybe<LicenseAssignmentUpdateInput>;
};

export type BulkLicenseActionResult = {
  __typename?: 'BulkLicenseActionResult';
  request: LicenseActionRequest;
  licenses?: Maybe<Array<License>>;
  error?: Maybe<Scalars['String']>;
};

export type BulkLicenseActionWhereInput = {
  expiresAfter?: Maybe<Scalars['DateTime']>;
  ignoreLicenseOverage?: Maybe<Scalars['Boolean']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
};

export type Character = {
  __typename?: 'Character';
  id: Scalars['Int'];
  character: Scalars['String'];
  characterCase?: Maybe<CharacterCase>;
  characterType: CharacterType;
};

export enum CharacterCase {
  LOWERCASE = 'LOWERCASE',
  UPPERCASE = 'UPPERCASE',
}

export type CharacterInput = {
  characterId: Scalars['Int'];
  character: Scalars['String'];
  characterCase?: Maybe<CharacterCase>;
  characterType: CharacterType;
};

export enum CharacterOrderField {
  ID = 'ID',
  TYPE = 'TYPE',
  TITLE = 'TITLE',
}

export type CharacterProgress = {
  __typename?: 'CharacterProgress';
  characterId: Scalars['Int'];
  character?: Maybe<Character>;
  readingLogCount: Scalars['Int'];
  bookReadCount: Scalars['Int'];
  activityCompletedCount: Scalars['Int'];
  activityTotalCount: Scalars['Int'];
};

export type CharacterRewards = {
  __typename?: 'CharacterRewards';
  characterId: Scalars['Int'];
  character: Character;
  studentRewards: Array<StudentReward>;
};

export enum CharacterType {
  PRINT = 'PRINT',
  CURSIVE = 'CURSIVE',
  NUMBER = 'NUMBER',
}

export type CharacterWhereInput = {
  id?: Maybe<Scalars['Int']>;
  character?: Maybe<Scalars['String']>;
  characterType?: Maybe<CharacterType>;
  characterCase?: Maybe<CharacterCase>;
};

export type CharactersWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  character?: Maybe<Array<Scalars['String']>>;
  characterType?: Maybe<CharacterType>;
  characterCase?: Maybe<CharacterCase>;
};

export type Classroom = {
  __typename?: 'Classroom';
  id: Scalars['Int'];
  externalId?: Maybe<ExternalId>;
  sisId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  color: Scalars['String'];
  loginType: StudentLoginType;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  academicSessionId?: Maybe<Scalars['Int']>;
  academicSession?: Maybe<AcademicSession>;
  studentCount: Scalars['Int'];
  students?: Maybe<Array<Student>>;
  users?: Maybe<Array<UserClassroomEnrollment>>;
  settings?: Maybe<Array<ClassroomSetting>>;
  stats: ClassroomStats;
  status?: Maybe<ClassroomStatus>;
  dateArchived?: Maybe<Scalars['DateTime']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  groups?: Maybe<Array<Group>>;
  licenseUsage?: Maybe<Array<ClassroomLicenseUsage>>;
};

export type ClassroomUsersArgs = {
  where?: Maybe<UsersWhereInput>;
};

export type ClassroomSettingsArgs = {
  where?: Maybe<ClassroomSettingsWhereInput>;
  orderBy?: Maybe<ClassroomSettingsOrderInput>;
};

export type ClassroomGroupsArgs = {
  where?: Maybe<GroupsWhereInput>;
  orderBy?: Maybe<GroupsOrderInput>;
};

export type ClassroomLicenseUsageArgs = {
  where?: Maybe<LicenseUsageWhereInput>;
};

export type ClassroomCreateInput = {
  externalId?: Maybe<ExternalIdInput>;
  sisId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  organizationId: Scalars['Int'];
  academicSessionId?: Maybe<Scalars['Int']>;
  loginType?: Maybe<StudentLoginType>;
  dateArchived?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
  students?: Maybe<Array<StudentCreateInput>>;
  studentEnrollments?: Maybe<Array<Scalars['Int']>>;
  userEnrollments?: Maybe<Array<UserEnrollmentInput>>;
  settings?: Maybe<Array<BaseSettingCreateInput>>;
};

export type ClassroomLicenseUsage = {
  __typename?: 'ClassroomLicenseUsage';
  product: Product;
  productId: Scalars['Int'];
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  assignedCount: Scalars['Int'];
};

export enum ClassroomOrderField {
  ID = 'ID',
  ORGANIZATION_ID = 'ORGANIZATION_ID',
  NAME = 'NAME',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID',
  DATE_ARCHIVED = 'DATE_ARCHIVED',
  DATE_CREATED = 'DATE_CREATED',
  DATE_REMOVED = 'DATE_REMOVED',
}

export type ClassroomPrivilege = {
  __typename?: 'ClassroomPrivilege';
  id: Scalars['Int'];
  name: Scalars['String'];
  displayName: Scalars['String'];
};

export enum ClassroomPrivilegeOrderField {
  ID = 'ID',
  NAME = 'NAME',
  DISPLAY_NAME = 'DISPLAY_NAME',
}

export type ClassroomPrivilegeWhereInput = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type ClassroomPrivilegesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ClassroomPrivilegeOrderField>;
};

export type ClassroomPrivilegesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
};

export type ClassroomRole = {
  __typename?: 'ClassroomRole';
  id: Scalars['Int'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  classification: ClassroomRoleClassification;
  appId?: Maybe<Scalars['Int']>;
  app?: Maybe<App>;
  organizationId?: Maybe<Scalars['Int']>;
  organization?: Maybe<Organization>;
  privileges?: Maybe<Array<Maybe<ClassroomPrivilege>>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export enum ClassroomRoleClassification {
  EDUCATOR = 'EDUCATOR',
  COEDUCATOR = 'COEDUCATOR',
}

export enum ClassroomRoleOrderField {
  ID = 'ID',
  NAME = 'NAME',
  DISPLAY_NAME = 'DISPLAY_NAME',
  APP = 'APP',
  ORGANIZATION = 'ORGANIZATION',
}

export type ClassroomRoleWhereInput = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type ClassroomRolesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ClassroomRoleOrderField>;
};

export type ClassroomRolesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
  appId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
};

export type ClassroomSetting = {
  __typename?: 'ClassroomSetting';
  id: Scalars['Int'];
  appId: Scalars['Int'];
  productId?: Maybe<Scalars['Int']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  classroomId: Scalars['Int'];
  setting: Scalars['String'];
  value: Scalars['JSON'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  app: App;
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  classroom: Classroom;
};

export type ClassroomSettingCreateInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  classroomId: Scalars['Int'];
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export enum ClassroomSettingOrderField {
  APP_ID = 'APP_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  SETTING = 'SETTING',
  CLASSROOM_ID = 'CLASSROOM_ID',
}

export type ClassroomSettingUpdateInput = {
  setting?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  classroomId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['JSON']>;
};

export type ClassroomSettingWhereInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  classroomId: Scalars['Int'];
  setting: Scalars['String'];
};

export type ClassroomSettingsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ClassroomSettingOrderField>;
};

export type ClassroomSettingsUpdateInput = {
  setting?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  classroomId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['JSON']>;
};

export type ClassroomSettingsWhereInput = {
  appId?: Maybe<Array<Scalars['Int']>>;
  appName?: Maybe<Array<Scalars['String']>>;
  productId?: Maybe<Array<Scalars['Int']>>;
  productCode?: Maybe<Array<Scalars['String']>>;
  productCurriculumId?: Maybe<Array<Scalars['Int']>>;
  productCurriculumCode?: Maybe<Array<Scalars['String']>>;
  classroomId?: Maybe<Array<Scalars['Int']>>;
  setting?: Maybe<Array<Scalars['String']>>;
};

export type ClassroomStats = {
  __typename?: 'ClassroomStats';
  studentCount: Scalars['Int'];
  userCount: Scalars['Int'];
};

export enum ClassroomStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  REMOVED = 'REMOVED',
}

export type ClassroomUpdateInput = {
  externalId?: Maybe<ExternalIdUpdateInput>;
  sisId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  academicSessionId?: Maybe<Scalars['Int']>;
  loginType?: Maybe<StudentLoginType>;
  userEnrollments?: Maybe<Array<UserEnrollmentInput>>;
  dateArchived?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type ClassroomWhereInput = {
  externalId?: Maybe<ExternalIdInput>;
  id?: Maybe<Scalars['Int']>;
};

export type ClassroomsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ClassroomOrderField>;
};

export type ClassroomsUpdateInput = {
  organizationId?: Maybe<Scalars['Int']>;
  academicSessionId?: Maybe<Scalars['Int']>;
  dateArchived?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type ClassroomsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  includeRemoved?: Maybe<Scalars['Boolean']>;
  educator?: Maybe<UsersWhereInput>;
  coEducator?: Maybe<UsersWhereInput>;
  sourceId?: Maybe<Array<Scalars['String']>>;
  sourceKind?: Maybe<Array<SourceKind>>;
  name?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  organization?: Maybe<OrganizationsWhereInput>;
  academicSessionId?: Maybe<Array<Scalars['Int']>>;
  archived?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Array<ClassroomStatus>>;
  AND?: Maybe<Array<ClassroomsWhereInput>>;
  OR?: Maybe<Array<ClassroomsWhereInput>>;
};

export type Contact = {
  __typename?: 'Contact';
  id: Scalars['Int'];
  externalId?: Maybe<ExternalId>;
  sisId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  students?: Maybe<Array<Student>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type ContactInput = {
  externalId?: Maybe<ExternalIdInput>;
  sisId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  studentIds?: Maybe<Array<Scalars['Int']>>;
};

export enum ContactOrderField {
  ID = 'ID',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID',
}

export type ContactStudentRemoveInput = {
  studentId?: Maybe<Array<Scalars['Int']>>;
  contactId: Scalars['Int'];
};

export type ContactUpdateInput = {
  externalId?: Maybe<ExternalIdUpdateInput>;
  sisId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ContactWhereInput = {
  externalId?: Maybe<ExternalIdInput>;
  id?: Maybe<Scalars['Int']>;
};

export type ContactsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ContactOrderField>;
};

export type ContactsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  sourceId?: Maybe<Array<Scalars['String']>>;
  sourceKind?: Maybe<Array<SourceKind>>;
  email?: Maybe<Array<Scalars['String']>>;
  email_contains?: Maybe<Scalars['String']>;
  firstName?: Maybe<Array<Scalars['String']>>;
  firstName_contains?: Maybe<Scalars['String']>;
  lastName?: Maybe<Array<Scalars['String']>>;
  lastName_contains?: Maybe<Scalars['String']>;
  AND?: Maybe<Array<ContactsWhereInput>>;
  OR?: Maybe<Array<ContactsWhereInput>>;
};

export type CreateEntityLicenseAssignInput = {
  productId?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
};

export type CreateReadingLogInput = {
  bookId: Scalars['Int'];
  pagesRead: Scalars['Int'];
  dateStarted: Scalars['DateTime'];
  dateCompleted: Scalars['DateTime'];
};

export type DefaultGroupSetting = {
  __typename?: 'DefaultGroupSetting';
  gradeLevels: Array<Scalars['String']>;
  productCodes: Array<Scalars['String']>;
  group: GroupCreate;
};

export type Enrollment = {
  __typename?: 'Enrollment';
  id: Scalars['Int'];
  classroom: Classroom;
  student?: Maybe<Student>;
  user?: Maybe<User>;
  classroomRole?: Maybe<ClassroomRole>;
  removedDate?: Maybe<Scalars['DateTime']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export enum EnrollmentOrderField {
  STUDENT_ID = 'STUDENT_ID',
  USER_ID = 'USER_ID',
  CLASSROOM_ROLE = 'CLASSROOM_ROLE',
  CLASSROOM_ROLE_ID = 'CLASSROOM_ROLE_ID',
}

export type EnrollmentWhereInput = {
  id: Scalars['Int'];
};

export type EnrollmentsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<EnrollmentOrderField>;
};

export type EnrollmentsWhereInput = {
  id?: Maybe<Array<Maybe<Scalars['Int']>>>;
  classroomId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  studentId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  userId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  classroomRoleId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  classroomRole?: Maybe<Array<Maybe<UserRole>>>;
};

export type ExternalId = {
  __typename?: 'ExternalId';
  sourceKindId: Scalars['Int'];
  sourceKind: SourceKind;
  sourceId: Scalars['String'];
};

export type ExternalIdInput = {
  sourceKind: SourceKind;
  sourceId: Scalars['String'];
};

export type ExternalIdUpdateInput = {
  sourceKind?: Maybe<SourceKind>;
  sourceId?: Maybe<Scalars['String']>;
};

export type FeatureToggle = {
  __typename?: 'FeatureToggle';
  id: Scalars['Int'];
  appId: Scalars['Int'];
  app: App;
  name: Scalars['String'];
  enabled: Scalars['Boolean'];
  data?: Maybe<Scalars['JSON']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export type FeatureToggleInput = {
  appId: Scalars['Int'];
  name: Scalars['String'];
  enabled: Scalars['Boolean'];
  data?: Maybe<Scalars['JSON']>;
};

export enum FeatureToggleOrderField {
  ID = 'ID',
  APP_ID = 'APP_ID',
  NAME = 'NAME',
  ENABLED = 'ENABLED',
  DATE_CREATED = 'DATE_CREATED',
}

export type FeatureToggleUpdateInput = {
  appId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  data?: Maybe<Scalars['JSON']>;
};

export type FeatureToggleWhereInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
};

export type FeatureTogglesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<FeatureToggleOrderField>;
};

export type FeatureTogglesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  appId?: Maybe<Array<Scalars['Int']>>;
  appName?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Array<Scalars['String']>>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type FeelingsMatchActivity = IActivity & {
  __typename?: 'FeelingsMatchActivity';
  id: Scalars['Int'];
  activityTypeId: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  bookId: Scalars['Int'];
  book?: Maybe<Book>;
  activityType?: Maybe<ActivityType>;
  rounds: Array<FeelingsMatchRound>;
};

export type FeelingsMatchCard = {
  __typename?: 'FeelingsMatchCard';
  cardBack: Asset;
  cardTouch: Asset;
  affirmation?: Maybe<Asset>;
};

export type FeelingsMatchInstructions = {
  __typename?: 'FeelingsMatchInstructions';
  introduction: Asset;
  end: Asset;
};

export type FeelingsMatchRound = {
  __typename?: 'FeelingsMatchRound';
  instructions?: Maybe<FeelingsMatchInstructions>;
  cardFront?: Maybe<Asset>;
  cards: Array<FeelingsMatchCard>;
};

export type FileUpload = {
  __typename?: 'FileUpload';
  id: Scalars['Int'];
  originalFilename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  mimeType: MimeType;
  url: Scalars['String'];
  size: Scalars['Int'];
};

export type FileUploadInput = {
  file: Scalars['Upload'];
  description?: Maybe<Scalars['String']>;
};

export type FindAvailableLicenseWhereInput = {
  expiresAfter?: Maybe<Scalars['DateTime']>;
  ignoreLicenseOverage?: Maybe<Scalars['Boolean']>;
  gradeLevel?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  product?: Maybe<ProductIdentifierInput>;
  productFamily?: Maybe<ProductIdentifierInput>;
  limit?: Maybe<Scalars['Int']>;
};

export type FindTheLetterActivity = IActivity & {
  __typename?: 'FindTheLetterActivity';
  id: Scalars['Int'];
  activityTypeId: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  bookId: Scalars['Int'];
  instructions: Asset;
  sound: Asset;
  book?: Maybe<Book>;
  activityType?: Maybe<ActivityType>;
  pages: Array<FindTheLetterPage>;
};

export type FindTheLetterAsset = IAsset & {
  __typename?: 'FindTheLetterAsset';
  id: Scalars['Int'];
  type: AssetType;
  src: Scalars['String'];
  vtt?: Maybe<Scalars['String']>;
  captions?: Maybe<Scalars['JSON']>;
  narrationSrc?: Maybe<Scalars['String']>;
  narrationVtt?: Maybe<Scalars['String']>;
  narrationCaptions?: Maybe<Scalars['JSON']>;
  description: Scalars['String'];
  occurrences?: Maybe<Scalars['Int']>;
  spreadLayout?: Maybe<Scalars['Boolean']>;
};

export type FindTheLetterPage = {
  __typename?: 'FindTheLetterPage';
  pageId: Scalars['Int'];
  page: Page;
  contents?: Maybe<FindTheLetterAsset>;
  png?: Maybe<FindTheLetterAsset>;
};

export type FindTheObjectsActivity = IActivity & {
  __typename?: 'FindTheObjectsActivity';
  id: Scalars['Int'];
  activityTypeId: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  bookId: Scalars['Int'];
  instructions: Array<Asset>;
  book?: Maybe<Book>;
  activityType?: Maybe<ActivityType>;
  pages: Array<FindTheObjectsPage>;
};

export type FindTheObjectsAsset = IAsset & {
  __typename?: 'FindTheObjectsAsset';
  id: Scalars['Int'];
  type: AssetType;
  src: Scalars['String'];
  vtt?: Maybe<Scalars['String']>;
  captions?: Maybe<Scalars['JSON']>;
  narrationSrc?: Maybe<Scalars['String']>;
  narrationVtt?: Maybe<Scalars['String']>;
  narrationCaptions?: Maybe<Scalars['JSON']>;
  description: Scalars['String'];
  occurrences: Scalars['Int'];
  animation: Scalars['Boolean'];
};

export type FindTheObjectsPage = {
  __typename?: 'FindTheObjectsPage';
  pageId: Scalars['Int'];
  page: Page;
  contents?: Maybe<Asset>;
  svg?: Maybe<Asset>;
  animation?: Maybe<Asset>;
  objects?: Maybe<Array<FindTheObjectsAsset>>;
};

export enum GradeLevel {
  PK = 'PK',
  TK = 'TK',
  K = 'K',
  FIRST = 'FIRST',
  SECOND = 'SECOND',
  THIRD = 'THIRD',
  FOURTH = 'FOURTH',
  FIFTH = 'FIFTH',
}

export type Group = {
  __typename?: 'Group';
  id: Scalars['Int'];
  appId: Scalars['Int'];
  app: App;
  classroomId: Scalars['Int'];
  classroom: Classroom;
  groupCategoryId: Scalars['Int'];
  groupCategory: GroupCategory;
  name: Scalars['String'];
  groupEnrollments: Array<Maybe<GroupEnrollment>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export type GroupCategoriesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<GroupCategoryOrderField>;
};

export type GroupCategoriesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  appId?: Maybe<Array<Scalars['Int']>>;
  classroomId?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
};

export type GroupCategory = {
  __typename?: 'GroupCategory';
  id: Scalars['Int'];
  appId: Scalars['Int'];
  app: App;
  classroomId: Scalars['Int'];
  classroom: Classroom;
  name: Scalars['String'];
  groups: Array<Maybe<Group>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export type GroupCategoryCreate = {
  __typename?: 'GroupCategoryCreate';
  id?: Maybe<Scalars['Int']>;
  appId: Scalars['Int'];
  name: Scalars['String'];
};

export type GroupCategoryCreateInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  name: Scalars['String'];
};

export enum GroupCategoryOrderField {
  ID = 'ID',
  CLASSROOM_ID = 'CLASSROOM_ID',
  NAME = 'NAME',
}

export type GroupCategoryUpsertInput = {
  id?: Maybe<Scalars['Int']>;
  appId?: Maybe<Scalars['Int']>;
  classroomId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type GroupCategoryWhereInput = {
  id?: Maybe<Scalars['Int']>;
  appId?: Maybe<Scalars['Int']>;
  classroomId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type GroupCreate = {
  __typename?: 'GroupCreate';
  id?: Maybe<Scalars['Int']>;
  appId: Scalars['Int'];
  name: Scalars['String'];
  groupCategory?: Maybe<GroupCategoryCreate>;
};

export type GroupCreateInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  groupCategory: GroupCategoryCreateInput;
  name: Scalars['String'];
};

export type GroupEnrollment = {
  __typename?: 'GroupEnrollment';
  id: Scalars['Int'];
  groupId: Scalars['Int'];
  group?: Maybe<Group>;
  studentId: Scalars['Int'];
  student?: Maybe<Student>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export enum GroupEnrollmentAction {
  ENROLL = 'ENROLL',
  UNENROLL = 'UNENROLL',
}

export type GroupEnrollmentGroupCategoryInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  name: Scalars['String'];
};

export type GroupEnrollmentGroupInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  groupCategory?: Maybe<GroupEnrollmentGroupCategoryInput>;
  name: Scalars['String'];
};

export enum GroupEnrollmentOrderField {
  ID = 'ID',
  GROUP_ID = 'GROUP_ID',
  STUDENT_ID = 'STUDENT_ID',
}

export type GroupEnrollmentWhereInput = {
  id?: Maybe<Scalars['Int']>;
  groupId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

export type GroupEnrollmentsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<GroupEnrollmentOrderField>;
};

export type GroupEnrollmentsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  groupId?: Maybe<Array<Scalars['Int']>>;
  studentId?: Maybe<Array<Scalars['Int']>>;
};

export enum GroupOrderField {
  ID = 'ID',
  CLASSROOM_ID = 'CLASSROOM_ID',
  GROUP_CATEGORY_ID = 'GROUP_CATEGORY_ID',
  NAME = 'NAME',
}

export type GroupUnenrollmentInput = {
  groupId: Scalars['Int'];
  studentId: Scalars['Int'];
};

export type GroupUpdateInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type GroupUpsertInput = {
  id?: Maybe<Scalars['Int']>;
  appId?: Maybe<Scalars['Int']>;
  classroomId?: Maybe<Scalars['Int']>;
  groupCategory?: Maybe<GroupCategoryUpsertInput>;
  name: Scalars['String'];
};

export type GroupWhereInput = {
  id?: Maybe<Scalars['Int']>;
  appId?: Maybe<Scalars['Int']>;
  classroomId?: Maybe<Scalars['Int']>;
  groupCategoryId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type GroupsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<GroupOrderField>;
};

export type GroupsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  appId?: Maybe<Array<Scalars['Int']>>;
  classroomId?: Maybe<Array<Scalars['Int']>>;
  groupCategoryId?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
};

export type GuessTheOrderActivity = IActivity & {
  __typename?: 'GuessTheOrderActivity';
  id: Scalars['Int'];
  activityTypeId: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  bookId: Scalars['Int'];
  instructions: GuessTheOrderInstructions;
  book?: Maybe<Book>;
  activityType?: Maybe<ActivityType>;
  storyElements: Array<GuessTheOrderStoryElement>;
};

export type GuessTheOrderInstructions = {
  __typename?: 'GuessTheOrderInstructions';
  introduction: Asset;
  summary: Asset;
};

export type GuessTheOrderStoryElement = {
  __typename?: 'GuessTheOrderStoryElement';
  instructions: Asset;
  affirmation: Asset;
  tile: GuessTheOrderTile;
  scene: Asset;
};

export type GuessTheOrderTile = {
  __typename?: 'GuessTheOrderTile';
  id: Scalars['Int'];
  src: Scalars['String'];
  vtt?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  storyOrder: StoryElementOrder;
};

export type GuessWhereActivity = IActivity & {
  __typename?: 'GuessWhereActivity';
  id: Scalars['Int'];
  activityTypeId: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  bookId: Scalars['Int'];
  book?: Maybe<Book>;
  activityType?: Maybe<ActivityType>;
  scene?: Maybe<Asset>;
  rounds: Array<Maybe<GuessWhereRound>>;
};

export type GuessWhereImage = IAsset & {
  __typename?: 'GuessWhereImage';
  id: Scalars['Int'];
  type: AssetType;
  src: Scalars['String'];
  vtt?: Maybe<Scalars['String']>;
  captions?: Maybe<Scalars['JSON']>;
  narrationSrc?: Maybe<Scalars['String']>;
  narrationVtt?: Maybe<Scalars['String']>;
  narrationCaptions?: Maybe<Scalars['JSON']>;
  description: Scalars['String'];
  elementId?: Maybe<Scalars['String']>;
  correct: Scalars['Boolean'];
};

export type GuessWhereRound = {
  __typename?: 'GuessWhereRound';
  instructions: Asset;
  question: Asset;
  answer?: Maybe<Asset>;
  tiles: Array<GuessWhereTile>;
};

export type GuessWhereTile = {
  __typename?: 'GuessWhereTile';
  image: GuessWhereImage;
  audio?: Maybe<Asset>;
  affirmation?: Maybe<Asset>;
};

export type GuessWhoActivity = IActivity & {
  __typename?: 'GuessWhoActivity';
  id: Scalars['Int'];
  activityTypeId: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  bookId: Scalars['Int'];
  book?: Maybe<Book>;
  activityType?: Maybe<ActivityType>;
  rounds: Array<GuessWhoRound>;
  summary: Asset;
};

export type GuessWhoImage = IAsset & {
  __typename?: 'GuessWhoImage';
  id: Scalars['Int'];
  type: AssetType;
  src: Scalars['String'];
  vtt?: Maybe<Scalars['String']>;
  captions?: Maybe<Scalars['JSON']>;
  narrationSrc?: Maybe<Scalars['String']>;
  narrationVtt?: Maybe<Scalars['String']>;
  narrationCaptions?: Maybe<Scalars['JSON']>;
  description: Scalars['String'];
  correct: Scalars['Boolean'];
};

export type GuessWhoRound = {
  __typename?: 'GuessWhoRound';
  tiles: Array<GuessWhoTile>;
  question: Asset;
  answer?: Maybe<Asset>;
  affirmation: Asset;
  scene: Asset;
};

export type GuessWhoTile = {
  __typename?: 'GuessWhoTile';
  image: GuessWhoImage;
  audio?: Maybe<Asset>;
};

export type IActivity = {
  id: Scalars['Int'];
  activityTypeId: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  bookId: Scalars['Int'];
  book?: Maybe<Book>;
  activityType?: Maybe<ActivityType>;
};

export type IAsset = {
  id: Scalars['Int'];
  type: AssetType;
  src: Scalars['String'];
  vtt?: Maybe<Scalars['String']>;
  captions?: Maybe<Scalars['JSON']>;
  narrationSrc?: Maybe<Scalars['String']>;
  narrationVtt?: Maybe<Scalars['String']>;
  narrationCaptions?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
};

export type License = {
  __typename?: 'License';
  id: Scalars['Int'];
  licenseTypeId: Scalars['Int'];
  licenseType: LicenseType;
  orderItemId: Scalars['Int'];
  orderItem?: Maybe<OrderItem>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  product?: Maybe<Product>;
  productId: Scalars['Int'];
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  manualAssignment?: Maybe<Scalars['Boolean']>;
  siteLicense?: Maybe<SiteLicense>;
  siteLicenseId?: Maybe<Scalars['Int']>;
  student?: Maybe<Student>;
  studentId?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
  dateUsed?: Maybe<Scalars['DateTime']>;
  dateUpdatedAssignment?: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  dateExpiration: Scalars['DateTime'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export enum LicenseAction {
  ASSIGN = 'ASSIGN',
  UNASSIGN = 'UNASSIGN',
}

export type LicenseActionRequest = {
  __typename?: 'LicenseActionRequest';
  action?: Maybe<LicenseAction>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  gradeLevel?: Maybe<Scalars['String']>;
  productCode?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  replaceExistingProductFamilyLicense?: Maybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: Maybe<Scalars['Boolean']>;
  skipManualAssignment?: Maybe<Scalars['Boolean']>;
  studentId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  updates?: Maybe<LicenseAssignUpdates>;
};

export type LicenseAssignInput = {
  studentId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  productCurriculum?: Maybe<ProductIdentifierInput>;
  updates?: Maybe<LicenseAssignmentUpdateInput>;
};

export type LicenseAssignRequest = {
  __typename?: 'LicenseAssignRequest';
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  productCode?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  gradeLevel?: Maybe<Scalars['String']>;
  replaceExistingProductFamilyLicense?: Maybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: Maybe<Scalars['Boolean']>;
  skipManualAssignment?: Maybe<Scalars['Boolean']>;
  studentId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  updates?: Maybe<LicenseAssignUpdates>;
};

export type LicenseAssignUpdates = {
  __typename?: 'LicenseAssignUpdates';
  dateExpiration?: Maybe<Scalars['DateTime']>;
  dateUsed?: Maybe<Scalars['DateTime']>;
  organizationId?: Maybe<Scalars['Int']>;
};

export type LicenseAssignmentUpdateInput = {
  dateExpiration?: Maybe<Scalars['DateTime']>;
  dateUsed?: Maybe<Scalars['DateTime']>;
  manualAssignment?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['Int']>;
};

export type LicenseExpirationInput = {
  gracePeriodEndDate: Scalars['DateTime'];
  unlockDate: Scalars['DateTime'];
};

export enum LicenseOrderField {
  ID = 'ID',
  DATE_CREATED = 'DATE_CREATED',
  DATE_EXPIRATION = 'DATE_EXPIRATION',
  DATE_UPDATED_ASSIGNMENT = 'DATE_UPDATED_ASSIGNMENT',
  DATE_UPDATED = 'DATE_UPDATED',
  MANUAL_ASSIGNMENT = 'MANUAL_ASSIGNMENT',
  ORDER_ITEM_ID = 'ORDER_ITEM_ID',
  ORGANIZATION_ID = 'ORGANIZATION_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  STUDENT_ID = 'STUDENT_ID',
  USER_ID = 'USER_ID',
}

export enum LicenseStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  REMOVED = 'REMOVED',
}

export enum LicenseType {
  FULL = 'FULL',
  MULTI_YEAR = 'MULTI_YEAR',
  RENEWAL = 'RENEWAL',
  ADD_ON = 'ADD_ON',
  PRORATED = 'PRORATED',
  TRIAL = 'TRIAL',
  WORKSHOP = 'WORKSHOP',
  EMPLOYEE = 'EMPLOYEE',
  OVERAGE = 'OVERAGE',
}

export type LicenseUpdateInput = {
  dateExpiration?: Maybe<Scalars['DateTime']>;
  expiration?: Maybe<LicenseExpirationInput>;
  orderItemId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
};

export type LicenseUsageWhereInput = {
  product?: Maybe<Array<ProductIdentifierInput>>;
  productCurriculum?: Maybe<Array<ProductIdentifierInput>>;
  productFamily?: Maybe<Array<ProductIdentifierInput>>;
};

export type LicenseWhereInput = {
  id: Scalars['Int'];
  includeRemoved?: Maybe<Scalars['Boolean']>;
};

export type LicensesMastercodeWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  code?: Maybe<Array<Scalars['String']>>;
};

export type LicensesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<LicenseOrderField>;
};

export type LicensesOrderWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  orderNumber?: Maybe<Array<Scalars['String']>>;
  orderNumber_contains?: Maybe<Scalars['String']>;
  ecmsOrderNumber?: Maybe<Array<Scalars['String']>>;
  ecmsOrderNumber_contains?: Maybe<Scalars['String']>;
  AND?: Maybe<Array<LicensesOrderWhereInput>>;
  OR?: Maybe<Array<LicensesOrderWhereInput>>;
};

export type LicensesOrganizationWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
};

export type LicensesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  assigned?: Maybe<Scalars['Boolean']>;
  assigneeType?: Maybe<AssigneeType>;
  expired?: Maybe<Scalars['Boolean']>;
  includeRemoved?: Maybe<Scalars['Boolean']>;
  licenseType?: Maybe<Array<LicenseType>>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  organization?: Maybe<LicensesOrganizationWhereInput>;
  order?: Maybe<LicensesOrderWhereInput>;
  manualAssignment?: Maybe<Scalars['Boolean']>;
  mastercode?: Maybe<LicensesMastercodeWhereInput>;
  product?: Maybe<Array<ProductIdentifierInput>>;
  productCurriculum?: Maybe<Array<ProductIdentifierInput>>;
  productFamily?: Maybe<Array<ProductIdentifierInput>>;
  siteLicenseId?: Maybe<Array<Scalars['Int']>>;
  status?: Maybe<Array<LicenseStatus>>;
  studentId?: Maybe<Array<Scalars['Int']>>;
  userId?: Maybe<Array<Scalars['Int']>>;
  AND?: Maybe<Array<LicensesWhereInput>>;
  OR?: Maybe<Array<LicensesWhereInput>>;
};

export type LiteRouteActivity = {
  id: Scalars['Int'];
  activityTypeId: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  bookId: Scalars['Int'];
  url: Scalars['String'];
  book?: Maybe<Book>;
  activityType?: Maybe<ActivityType>;
};

export enum Locale {
  EN_US = 'EN_US',
  ES_US = 'ES_US',
}

export type LogApiErrorInput = {
  timestamp: Scalars['DateTime'];
  method: Scalars['String'];
  url: Scalars['String'];
  params?: Maybe<Scalars['JSON']>;
  body?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['Int']>;
  data?: Maybe<Scalars['JSON']>;
};

export type LogApplicationErrorInput = {
  timestamp: Scalars['DateTime'];
  message: Scalars['String'];
  context?: Maybe<Scalars['JSON']>;
  stack?: Maybe<Scalars['String']>;
};

export type LoginSuccessEventCreateInput = {
  timestamp: Scalars['DateTime'];
  authenticationSource: AuthenticationSource;
  classroomId?: Maybe<Scalars['Int']>;
  sessionId: Scalars['String'];
};

export type Mastercode = {
  __typename?: 'Mastercode';
  id: Scalars['Int'];
  code: Scalars['String'];
  ownerEmail?: Maybe<Scalars['String']>;
  parentMastercode?: Maybe<Mastercode>;
  parentMastercodeId?: Maybe<Scalars['Int']>;
  orderItems?: Maybe<Array<OrderItem>>;
  transferHistory?: Maybe<Array<MastercodeTransferHistory>>;
  status?: Maybe<MastercodeStatus>;
  dateGracePeriodEnd: Scalars['DateTime'];
  dateScheduledUnlock?: Maybe<Scalars['DateTime']>;
  dateUnlocked?: Maybe<Scalars['DateTime']>;
  dateExpired?: Maybe<Scalars['DateTime']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export enum MastercodeOrderField {
  ID = 'ID',
  CODE = 'CODE',
  OWNER_EMAIL = 'OWNER_EMAIL',
  DATE_CREATED = 'DATE_CREATED',
  DATE_UNLOCKED = 'DATE_UNLOCKED',
  DATE_REMOVED = 'DATE_REMOVED',
  DATE_SCHEDULED_UNLOCK = 'DATE_SCHEDULED_UNLOCK',
}

export type MastercodeOrderItemsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  licenseTypeId?: Maybe<Array<Scalars['Int']>>;
  licenseType?: Maybe<Array<LicenseType>>;
  trial?: Maybe<Scalars['Boolean']>;
};

export type MastercodeOrdersWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  psrentOrderId?: Maybe<Array<Scalars['Int']>>;
  orderNumber?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Array<Scalars['String']>>;
  userId?: Maybe<Array<Scalars['Int']>>;
};

export type MastercodeOrganizationsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
};

export enum MastercodeStatus {
  UNLOCKED = 'UNLOCKED',
  EXPIRED = 'EXPIRED',
  REMOVED = 'REMOVED',
  LOCKED = 'LOCKED',
  SCHEDULED = 'SCHEDULED',
}

export type MastercodeTransferHistoriesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  newOwnerEmail?: Maybe<Array<Scalars['String']>>;
  previousOwnerEmail?: Maybe<Array<Scalars['String']>>;
  mastercodeId?: Maybe<Array<Scalars['Int']>>;
};

export type MastercodeTransferHistory = {
  __typename?: 'MastercodeTransferHistory';
  id: Scalars['Int'];
  mastercodeId: Scalars['Int'];
  previousOwnerEmail: Scalars['String'];
  newOwnerEmail: Scalars['String'];
  dateTransferred: Scalars['DateTime'];
  mastercode?: Maybe<Mastercode>;
};

export enum MastercodeTransferHistoryOrderField {
  ID = 'ID',
  MASTERCODE_ID = 'MASTERCODE_ID',
  NEW_OWNER_EMAIL = 'NEW_OWNER_EMAIL',
  PREVIOUS_OWNER_EMAIL = 'PREVIOUS_OWNER_EMAIL',
  DATE_TRANSERRED = 'DATE_TRANSERRED',
}

export type MastercodeTransferHistoryOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<MastercodeTransferHistoryOrderField>;
};

export type MastercodeTransferHistoryWhereInput = {
  id: Scalars['Int'];
};

export type MastercodeTransferInput = {
  ownerEmail: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type MastercodeUpdateInput = {
  userId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  dateExpiration?: Maybe<Scalars['DateTime']>;
};

export type MastercodeWhereInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  ownerEmail?: Maybe<Scalars['String']>;
};

export type MastercodesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<MastercodeOrderField>;
};

export type MastercodesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  code?: Maybe<Array<Scalars['String']>>;
  expired?: Maybe<Scalars['Boolean']>;
  orderId?: Maybe<Array<Scalars['Int']>>;
  ownerEmail?: Maybe<Array<Scalars['String']>>;
  ownerEmail_contains?: Maybe<Scalars['String']>;
  parentMastercodeId?: Maybe<Array<Scalars['Int']>>;
  includeRemoved?: Maybe<Scalars['Boolean']>;
  unlocked?: Maybe<Scalars['Boolean']>;
  orders?: Maybe<MastercodeOrdersWhereInput>;
  orderItems?: Maybe<MastercodeOrderItemsWhereInput>;
  organizations?: Maybe<MastercodeOrganizationsWhereInput>;
  products?: Maybe<ProductsWhereInput>;
  status?: Maybe<Array<MastercodeStatus>>;
};

export type MatchItTrashItActivity = LiteRouteActivity & {
  __typename?: 'MatchItTrashItActivity';
  id: Scalars['Int'];
  activityTypeId: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  bookId: Scalars['Int'];
  url: Scalars['String'];
  book?: Maybe<Book>;
  activityType?: Maybe<ActivityType>;
};

export type Media = {
  __typename?: 'Media';
  src: Scalars['String'];
  mediaType: MediaType;
};

export enum MediaType {
  AUDIO = 'AUDIO',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
}

export enum MimeType {
  MPEG = 'MPEG',
  MP3 = 'MP3',
  AUDIO_MP4 = 'AUDIO_MP4',
  MP4 = 'MP4',
  PNG = 'PNG',
  JPG = 'JPG',
  JPEG = 'JPEG',
  PDF = 'PDF',
}

export type Mutation = {
  __typename?: 'Mutation';
  _dummyCore?: Maybe<Scalars['Boolean']>;
  /**
   * - Required privileges:
   *   - academic-session.create
   */
  createAcademicSession?: Maybe<AcademicSession>;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  updateAcademicSession?: Maybe<AcademicSession>;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  updateAcademicSessions?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  removeAcademicSession?: Maybe<AcademicSession>;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  removeAcademicSessions?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  archiveClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  archiveClassrooms?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom.create
   */
  createClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  removeClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  removeClassrooms?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  updateClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  updateClassrooms?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   * @deprecated Field no longer supported
   */
  createClassroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   * @deprecated Field no longer supported
   */
  updateClassroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   * @deprecated Field no longer supported
   */
  updateClassroomSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  saveClassroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  saveClassroomSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  removeClassroomSetting?: Maybe<Scalars['Void']>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  removeClassroomSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - contact.create
   */
  createContact?: Maybe<Contact>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  updateContact?: Maybe<Contact>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  updateContacts: BatchMutationResult;
  /**
   * - Required privileges:
   *   - contact.write
   */
  removeContact?: Maybe<Contact>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  removeContacts: BatchMutationResult;
  /**
   * - Required privileges:
   *   - contact.write
   */
  removeStudentFromContact: BatchMutationResult;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  enroll?: Maybe<Array<Maybe<Enrollment>>>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  unenroll?: Maybe<BatchMutationResult>;
  createFeatureToggle?: Maybe<FeatureToggle>;
  updateFeatureToggle?: Maybe<FeatureToggle>;
  updateFeatureToggles?: Maybe<BatchMutationResult>;
  removeFeatureToggle?: Maybe<FeatureToggle>;
  removeFeatureToggles?: Maybe<BatchMutationResult>;
  createGroup?: Maybe<Group>;
  updateGroup?: Maybe<Group>;
  removeGroup?: Maybe<Group>;
  removeGroups: BatchMutationResult;
  enrollGroup?: Maybe<Array<GroupEnrollment>>;
  unenrollGroup?: Maybe<BatchMutationResult>;
  bulkGroupEnrollmentAction?: Maybe<Array<BulkGroupEnrollmentActionResult>>;
  /**
   * - Required privileges:
   *   - organization.create
   */
  createOrganization?: Maybe<Organization>;
  /**
   * - Required privileges:
   *   - organization.write
   */
  updateOrganization?: Maybe<Organization>;
  /**
   * - Required privileges:
   *   - organization.write
   */
  updateOrganizations?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - organization.write
   */
  removeOrganization?: Maybe<Organization>;
  /**
   * - Required privileges:
   *   - organization.write
   */
  removeOrganizations?: Maybe<BatchMutationResult>;
  saveOrganizationSetting?: Maybe<OrganizationSetting>;
  saveOrganizationSettings?: Maybe<BatchMutationResult>;
  removeOrganizationSetting?: Maybe<Scalars['Void']>;
  removeOrganizationSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student.create
   */
  createStudent?: Maybe<Student>;
  /**
   * - Required privileges:
   *   - student.create
   */
  createStudents: Array<Maybe<Student>>;
  /**
   * - Required privileges:
   *   - student.write
   */
  updateStudent?: Maybe<Student>;
  /**
   * - Required privileges:
   *   - student.write
   */
  updateStudents?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student.write
   */
  removeStudent?: Maybe<Student>;
  /**
   * - Required privileges:
   *   - student.write
   */
  removeStudents?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student.write
   */
  transferStudent?: Maybe<Enrollment>;
  /**
   * - Required privileges:
   *   - student-setting.write
   * @deprecated Field no longer supported
   */
  createStudentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student-setting.write
   * @deprecated Field no longer supported
   */
  updateStudentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student-setting.write
   * @deprecated Field no longer supported
   */
  updateStudentSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  saveStudentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  saveStudentSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  removeStudentSetting?: Maybe<Scalars['Void']>;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  removeStudentSettings?: Maybe<BatchMutationResult>;
  saveToursSettings: Array<Maybe<TourSettings>>;
  /**
   * - Required privileges:
   *   - user.create
   */
  createUser?: Maybe<User>;
  updateMe?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user.write
   */
  updateUser?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user.write
   */
  updateUsers?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user.write
   */
  removeUser?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user.write
   */
  removeUsers?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user-setting.write
   * @deprecated Field no longer supported
   */
  createUserSetting?: Maybe<UserSetting>;
  /**
   * - Required privileges:
   *   - user-setting.write
   * @deprecated Field no longer supported
   */
  updateUserSetting?: Maybe<UserSetting>;
  /**
   * - Required privileges:
   *   - user-setting.write
   * @deprecated Field no longer supported
   */
  updateUserSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  saveUserSetting?: Maybe<UserSetting>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  saveUserSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  removeUserSetting?: Maybe<Scalars['Void']>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  removeUserSettings?: Maybe<BatchMutationResult>;
  _dummyFulfillment?: Maybe<Scalars['Boolean']>;
  scheduleUnlockMastercode: Mastercode;
  scheduleUnlockOrderMastercodes: BatchMutationResult;
  transferMastercode: Mastercode;
  transferOrderMastercodes: BatchMutationResult;
  unlockMastercode: ProvisioningResult;
  unlockOrderMastercodes: ProvisioningResult;
  extendMastercode: Mastercode;
  expireMastercode: Mastercode;
  moveMastercode: Mastercode;
  _dummyLicenseManager?: Maybe<Scalars['Boolean']>;
  assignAvailableLicense?: Maybe<License>;
  assignLicense?: Maybe<License>;
  bulkAssignAvailableLicenses: Array<BulkAssignResult>;
  bulkLicenseAction: Array<BulkLicenseActionResult>;
  swapLicenses: Array<Maybe<License>>;
  unassignLicense?: Maybe<License>;
  unassignLicenses?: Maybe<BatchMutationResult>;
  updateLicense?: Maybe<License>;
  updateLicenses?: Maybe<BatchMutationResult>;
  updateSiteLicense?: Maybe<SiteLicense>;
  updateSiteLicenses?: Maybe<BatchMutationResult>;
  saveAttempt?: Maybe<Attempt>;
  createReadingLog?: Maybe<ReadingLog>;
  selectStudentReward?: Maybe<CharacterRewards>;
  createAccessActivityEvent?: Maybe<Scalars['Void']>;
  createAccessActivityPageEvent?: Maybe<Scalars['Void']>;
  createAccessLinkEvent?: Maybe<Scalars['Void']>;
  createAccessResourceEvent?: Maybe<Scalars['Void']>;
  createReadBookEvent?: Maybe<Scalars['Void']>;
  logApiError?: Maybe<Scalars['Void']>;
  logApplicationError?: Maybe<Scalars['Void']>;
};

export type MutationCreateAcademicSessionArgs = {
  data: AcademicSessionCreateInput;
};

export type MutationUpdateAcademicSessionArgs = {
  where: AcademicSessionWhereInput;
  data: AcademicSessionUpdateInput;
};

export type MutationUpdateAcademicSessionsArgs = {
  where: AcademicSessionsWhereInput;
  data: AcademicSessionsUpdateInput;
};

export type MutationRemoveAcademicSessionArgs = {
  where: AcademicSessionWhereInput;
};

export type MutationRemoveAcademicSessionsArgs = {
  where: AcademicSessionsWhereInput;
};

export type MutationArchiveClassroomArgs = {
  where: ClassroomWhereInput;
};

export type MutationArchiveClassroomsArgs = {
  where: ClassroomsWhereInput;
};

export type MutationCreateClassroomArgs = {
  data: ClassroomCreateInput;
};

export type MutationRemoveClassroomArgs = {
  where: ClassroomWhereInput;
};

export type MutationRemoveClassroomsArgs = {
  where: ClassroomsWhereInput;
};

export type MutationUpdateClassroomArgs = {
  where: ClassroomWhereInput;
  data: ClassroomUpdateInput;
};

export type MutationUpdateClassroomsArgs = {
  where: ClassroomsWhereInput;
  data: ClassroomsUpdateInput;
};

export type MutationCreateClassroomSettingArgs = {
  data: ClassroomSettingCreateInput;
};

export type MutationUpdateClassroomSettingArgs = {
  where: ClassroomSettingWhereInput;
  data: ClassroomSettingUpdateInput;
};

export type MutationUpdateClassroomSettingsArgs = {
  where: ClassroomSettingsWhereInput;
  data: ClassroomSettingsUpdateInput;
};

export type MutationSaveClassroomSettingArgs = {
  where: ClassroomSettingWhereInput;
  value: Scalars['JSON'];
};

export type MutationSaveClassroomSettingsArgs = {
  where: ClassroomSettingsWhereInput;
  value: Scalars['JSON'];
};

export type MutationRemoveClassroomSettingArgs = {
  where: ClassroomSettingWhereInput;
};

export type MutationRemoveClassroomSettingsArgs = {
  where: ClassroomSettingsWhereInput;
};

export type MutationCreateContactArgs = {
  data: ContactInput;
};

export type MutationUpdateContactArgs = {
  where: ContactWhereInput;
  data: ContactUpdateInput;
};

export type MutationUpdateContactsArgs = {
  where: ContactsWhereInput;
  data: ContactUpdateInput;
};

export type MutationRemoveContactArgs = {
  where: ContactWhereInput;
};

export type MutationRemoveContactsArgs = {
  where: ContactsWhereInput;
};

export type MutationRemoveStudentFromContactArgs = {
  data: ContactStudentRemoveInput;
};

export type MutationEnrollArgs = {
  classroomId: Scalars['Int'];
  studentIds?: Maybe<Array<Scalars['Int']>>;
  userEnrollments?: Maybe<Array<UserEnrollmentInput>>;
};

export type MutationUnenrollArgs = {
  classroomId: Scalars['Int'];
  studentIds?: Maybe<Array<Scalars['Int']>>;
  userEnrollments?: Maybe<Array<UserEnrollmentInput>>;
};

export type MutationCreateFeatureToggleArgs = {
  data: FeatureToggleInput;
};

export type MutationUpdateFeatureToggleArgs = {
  where: FeatureToggleWhereInput;
  data: FeatureToggleUpdateInput;
};

export type MutationUpdateFeatureTogglesArgs = {
  where: FeatureTogglesWhereInput;
  data: FeatureToggleUpdateInput;
};

export type MutationRemoveFeatureToggleArgs = {
  where: FeatureToggleWhereInput;
};

export type MutationRemoveFeatureTogglesArgs = {
  where: FeatureTogglesWhereInput;
};

export type MutationCreateGroupArgs = {
  data: GroupCreateInput;
};

export type MutationUpdateGroupArgs = {
  data: GroupUpdateInput;
};

export type MutationRemoveGroupArgs = {
  where: GroupWhereInput;
};

export type MutationRemoveGroupsArgs = {
  where: GroupsWhereInput;
};

export type MutationEnrollGroupArgs = {
  groupId: Scalars['Int'];
  studentIds: Array<Scalars['Int']>;
};

export type MutationUnenrollGroupArgs = {
  groupId: Scalars['Int'];
  studentIds: Array<Scalars['Int']>;
};

export type MutationBulkGroupEnrollmentActionArgs = {
  data: Array<BulkGroupEnrollmentActionInput>;
};

export type MutationCreateOrganizationArgs = {
  data: OrganizationCreateInput;
};

export type MutationUpdateOrganizationArgs = {
  where: OrganizationWhereInput;
  data: OrganizationUpdateInput;
};

export type MutationUpdateOrganizationsArgs = {
  where: OrganizationsWhereInput;
  data: OrganizationsUpdateInput;
};

export type MutationRemoveOrganizationArgs = {
  where: OrganizationWhereInput;
};

export type MutationRemoveOrganizationsArgs = {
  where: OrganizationsWhereInput;
};

export type MutationSaveOrganizationSettingArgs = {
  where: OrganizationSettingWhereInput;
  value: Scalars['JSON'];
};

export type MutationSaveOrganizationSettingsArgs = {
  where: OrganizationSettingsWhereInput;
  value: Scalars['JSON'];
};

export type MutationRemoveOrganizationSettingArgs = {
  where: OrganizationSettingWhereInput;
};

export type MutationRemoveOrganizationSettingsArgs = {
  where: OrganizationSettingsWhereInput;
};

export type MutationCreateStudentArgs = {
  data: StudentCreateInput;
};

export type MutationCreateStudentsArgs = {
  data: Array<StudentCreateInput>;
};

export type MutationUpdateStudentArgs = {
  where: StudentWhereInput;
  data: StudentUpdateInput;
};

export type MutationUpdateStudentsArgs = {
  where: StudentsWhereInput;
  data: StudentsUpdateInput;
};

export type MutationRemoveStudentArgs = {
  where: StudentWhereInput;
};

export type MutationRemoveStudentsArgs = {
  where: StudentsWhereInput;
};

export type MutationTransferStudentArgs = {
  where: TransferStudentWhereInput;
  data: TransferStudentInput;
};

export type MutationCreateStudentSettingArgs = {
  data: StudentSettingCreateInput;
};

export type MutationUpdateStudentSettingArgs = {
  where: StudentSettingWhereInput;
  data: StudentSettingUpdateInput;
};

export type MutationUpdateStudentSettingsArgs = {
  where: StudentSettingsWhereInput;
  data: StudentSettingsUpdateInput;
};

export type MutationSaveStudentSettingArgs = {
  where: StudentSettingWhereInput;
  value: Scalars['JSON'];
};

export type MutationSaveStudentSettingsArgs = {
  where: StudentSettingsWhereInput;
  value: Scalars['JSON'];
};

export type MutationRemoveStudentSettingArgs = {
  where: StudentSettingWhereInput;
};

export type MutationRemoveStudentSettingsArgs = {
  where: StudentSettingsWhereInput;
};

export type MutationSaveToursSettingsArgs = {
  data: SaveToursSettingsInput;
};

export type MutationCreateUserArgs = {
  data: UserCreateInput;
  upsert?: Maybe<Scalars['Boolean']>;
};

export type MutationUpdateMeArgs = {
  data: UserUpdateInput;
};

export type MutationUpdateUserArgs = {
  where: UserWhereInput;
  data: UserUpdateInput;
};

export type MutationUpdateUsersArgs = {
  where: UsersWhereInput;
  data: UsersUpdateInput;
};

export type MutationRemoveUserArgs = {
  where: UserWhereInput;
};

export type MutationRemoveUsersArgs = {
  where: UsersWhereInput;
};

export type MutationCreateUserSettingArgs = {
  data: UserSettingCreateInput;
};

export type MutationUpdateUserSettingArgs = {
  where: UserSettingWhereInput;
  data: UserSettingUpdateInput;
};

export type MutationUpdateUserSettingsArgs = {
  where: UserSettingsWhereInput;
  data: UserSettingsUpdateInput;
};

export type MutationSaveUserSettingArgs = {
  where: UserSettingWhereInput;
  value: Scalars['JSON'];
};

export type MutationSaveUserSettingsArgs = {
  where: UserSettingsWhereInput;
  value: Scalars['JSON'];
};

export type MutationRemoveUserSettingArgs = {
  where: UserSettingWhereInput;
};

export type MutationRemoveUserSettingsArgs = {
  where: UserSettingsWhereInput;
};

export type MutationScheduleUnlockMastercodeArgs = {
  where: MastercodeWhereInput;
  date: Scalars['DateTime'];
};

export type MutationScheduleUnlockOrderMastercodesArgs = {
  where: OrderWhereInput;
  date: Scalars['DateTime'];
};

export type MutationTransferMastercodeArgs = {
  where: MastercodeWhereInput;
  data: MastercodeTransferInput;
};

export type MutationTransferOrderMastercodesArgs = {
  where: OrderWhereInput;
  data: MastercodeTransferInput;
};

export type MutationUnlockMastercodeArgs = {
  where: MastercodeWhereInput;
};

export type MutationUnlockOrderMastercodesArgs = {
  where: OrderWhereInput;
};

export type MutationExtendMastercodeArgs = {
  where: MastercodeWhereInput;
  data: MastercodeUpdateInput;
};

export type MutationExpireMastercodeArgs = {
  where: MastercodeWhereInput;
  data?: Maybe<MastercodeUpdateInput>;
};

export type MutationMoveMastercodeArgs = {
  where: MastercodeWhereInput;
  data: MastercodeUpdateInput;
};

export type MutationAssignAvailableLicenseArgs = {
  where: AssignAvailableLicenseWhereInput;
  data: AssignAvailableLicenseInput;
};

export type MutationAssignLicenseArgs = {
  where: LicenseWhereInput;
  data: LicenseAssignInput;
};

export type MutationBulkAssignAvailableLicensesArgs = {
  where?: Maybe<BulkAssignAvailableWhereInput>;
  data: Array<BulkAssignAvailableLicenseInput>;
};

export type MutationBulkLicenseActionArgs = {
  where?: Maybe<BulkLicenseActionWhereInput>;
  data: Array<BulkLicenseActionInput>;
};

export type MutationSwapLicensesArgs = {
  where: SwapLicensesWhereInput;
  data: SwapLicensesInput;
};

export type MutationUnassignLicenseArgs = {
  where: LicenseWhereInput;
};

export type MutationUnassignLicensesArgs = {
  where: LicensesWhereInput;
};

export type MutationUpdateLicenseArgs = {
  where: LicenseWhereInput;
  data: LicenseUpdateInput;
};

export type MutationUpdateLicensesArgs = {
  where: LicensesWhereInput;
  data: LicenseUpdateInput;
};

export type MutationUpdateSiteLicenseArgs = {
  where: SiteLicenseWhereInput;
  data: SiteLicenseUpdateInput;
};

export type MutationUpdateSiteLicensesArgs = {
  where: SiteLicensesWhereInput;
  data: SiteLicenseUpdateInput;
};

export type MutationSaveAttemptArgs = {
  data: SaveAttemptInput;
  fileUpload?: Maybe<FileUploadInput>;
};

export type MutationCreateReadingLogArgs = {
  data: CreateReadingLogInput;
};

export type MutationSelectStudentRewardArgs = {
  data: SelectStudentRewardInput;
};

export type MutationCreateAccessActivityEventArgs = {
  data: AccessActivityEventCreateInput;
};

export type MutationCreateAccessActivityPageEventArgs = {
  data: AccessActivityPageEventCreateInput;
};

export type MutationCreateAccessLinkEventArgs = {
  data: AccessLinkEventCreateInput;
};

export type MutationCreateAccessResourceEventArgs = {
  data: AccessResourceEventCreateInput;
};

export type MutationCreateReadBookEventArgs = {
  data: ReadBookEventCreateInput;
};

export type MutationLogApiErrorArgs = {
  data: LogApiErrorInput;
};

export type MutationLogApplicationErrorArgs = {
  data: LogApplicationErrorInput;
};

export type Offset = {
  __typename?: 'Offset';
  top?: Maybe<Scalars['Int']>;
  left?: Maybe<Scalars['Int']>;
  bottom?: Maybe<Scalars['Int']>;
  right?: Maybe<Scalars['Int']>;
};

export type Order = {
  __typename?: 'Order';
  id: Scalars['Int'];
  orderNumber?: Maybe<Scalars['String']>;
  ecmsOrderNumber?: Maybe<Scalars['String']>;
  itemFulfillmentNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  cmsCustomerNumber?: Maybe<Scalars['String']>;
  crmNumber?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  parentOrder?: Maybe<Order>;
  parentOrderId?: Maybe<Scalars['Int']>;
  dateOrdered: Scalars['DateTime'];
  dateFulfilled?: Maybe<Scalars['DateTime']>;
  mastercodes?: Maybe<Array<Mastercode>>;
  orderItems?: Maybe<Array<OrderItem>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type OrderMastercodesArgs = {
  where?: Maybe<MastercodesWhereInput>;
};

export enum OrderDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type OrderItem = {
  __typename?: 'OrderItem';
  id: Scalars['Int'];
  order: Order;
  orderId: Scalars['Int'];
  lineId?: Maybe<Scalars['Int']>;
  lineNumber?: Maybe<Scalars['Int']>;
  mastercode?: Maybe<Mastercode>;
  mastercodeId: Scalars['Int'];
  product?: Maybe<Product>;
  productId: Scalars['Int'];
  licenseCount: Scalars['Int'];
  licenseTypeId: Scalars['Int'];
  licenseType: LicenseType;
  licenses?: Maybe<Array<License>>;
  siteLicense?: Maybe<SiteLicense>;
  multiyearTerm?: Maybe<Scalars['Int']>;
  siteLicenseRangeMin?: Maybe<Scalars['Int']>;
  siteLicenseRangeMax?: Maybe<Scalars['Int']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateExpiration?: Maybe<Scalars['DateTime']>;
};

export type OrderItemDateExpirationArgs = {
  where?: Maybe<OrderItemDateExpirationInput>;
};

export type OrderItemDateExpirationInput = {
  dateUnlocked?: Maybe<Scalars['DateTime']>;
};

export type OrderItemProvisioningResult = {
  __typename?: 'OrderItemProvisioningResult';
  orderItem?: Maybe<OrderItem>;
  orderItemId: Scalars['Int'];
  dateExpiration?: Maybe<Scalars['DateTime']>;
  licenseCount: Scalars['Int'];
};

export enum OrderOrderField {
  ID = 'ID',
  DATE_CREATED = 'DATE_CREATED',
  DATE_FULFILLED = 'DATE_FULFILLED',
  DATE_ORDERED = 'DATE_ORDERED',
  DATE_REMOVED = 'DATE_REMOVED',
  ITEM_FULFILLMENT_NUMBER = 'ITEM_FULFILLMENT_NUMBER',
  ORDER_NUMBER = 'ORDER_NUMBER',
  TYPE = 'TYPE',
  WEBSTORE_ORDER_NUMBER = 'WEBSTORE_ORDER_NUMBER',
}

export type OrderWhereInput = {
  id: Scalars['Int'];
  ownerEmail?: Maybe<Scalars['String']>;
};

export type OrdersOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<OrderOrderField>;
};

export type OrdersWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  completed?: Maybe<Scalars['Boolean']>;
  ecmsOrderNumber?: Maybe<Array<Scalars['String']>>;
  excludeTrialType?: Maybe<Scalars['Boolean']>;
  includeRemoved?: Maybe<Scalars['Boolean']>;
  itemFulfillmentNumber?: Maybe<Array<Scalars['String']>>;
  mastercodeId?: Maybe<Array<Scalars['Int']>>;
  mastercode?: Maybe<Array<Scalars['String']>>;
  ownerEmail?: Maybe<Array<Scalars['String']>>;
  ownerEmail_contains?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Array<Scalars['String']>>;
  parentOrderNumber?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<ProductsWhereInput>;
  type?: Maybe<Array<Scalars['String']>>;
  type_contains?: Maybe<Scalars['String']>;
  userId?: Maybe<Array<Scalars['Int']>>;
  AND?: Maybe<Array<OrdersWhereInput>>;
  OR?: Maybe<Array<OrdersWhereInput>>;
};

export type Organization = {
  __typename?: 'Organization';
  id: Scalars['Int'];
  externalId?: Maybe<ExternalId>;
  sisId?: Maybe<Scalars['String']>;
  ncesId?: Maybe<Scalars['String']>;
  mdrNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: OrganizationType;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  ancestorOrganizations?: Maybe<Array<Maybe<Organization>>>;
  parentOrganization?: Maybe<Organization>;
  parentOrganizationId?: Maybe<Scalars['Int']>;
  organizationTypeId?: Maybe<Scalars['Int']>;
  rootOrganization?: Maybe<Organization>;
  subOrganizations?: Maybe<Array<Maybe<Organization>>>;
  academicSessions?: Maybe<Array<Maybe<AcademicSession>>>;
  classrooms?: Maybe<Array<Classroom>>;
  users?: Maybe<Array<UserOrganization>>;
  settings?: Maybe<Array<OrganizationSetting>>;
  stats: OrganizationStats;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  mastercodes?: Maybe<Array<Mastercode>>;
  ancestorMastercodes?: Maybe<Array<Mastercode>>;
  licenses?: Maybe<Array<License>>;
  licenseUsage?: Maybe<Array<OrganizationLicenseUsage>>;
};

export type OrganizationAncestorOrganizationsArgs = {
  where?: Maybe<OrganizationsWhereInput>;
  maxHeight?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<OrganizationsOrderInput>;
};

export type OrganizationSubOrganizationsArgs = {
  where?: Maybe<OrganizationsWhereInput>;
  maxDepth?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<OrganizationsOrderInput>;
};

export type OrganizationAcademicSessionsArgs = {
  where?: Maybe<AcademicSessionsWhereInput>;
  orderBy?: Maybe<AcademicSessionsOrderInput>;
};

export type OrganizationUsersArgs = {
  where?: Maybe<UserOrganizationWhereInput>;
};

export type OrganizationSettingsArgs = {
  where?: Maybe<OrganizationSettingsWhereInput>;
  orderBy?: Maybe<OrganizationSettingsOrderInput>;
};

export type OrganizationMastercodesArgs = {
  where?: Maybe<MastercodesWhereInput>;
  orderBy?: Maybe<MastercodesOrderInput>;
};

export type OrganizationAncestorMastercodesArgs = {
  where?: Maybe<MastercodesWhereInput>;
  orderBy?: Maybe<MastercodesOrderInput>;
};

export type OrganizationLicensesArgs = {
  where?: Maybe<LicensesWhereInput>;
  orderBy?: Maybe<LicensesOrderInput>;
};

export type OrganizationLicenseUsageArgs = {
  where?: Maybe<LicenseUsageWhereInput>;
};

export type OrganizationCreateInput = {
  externalId?: Maybe<ExternalIdInput>;
  sisId?: Maybe<Scalars['String']>;
  ncesId?: Maybe<Scalars['String']>;
  mdrNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: OrganizationType;
  parentOrganizationId?: Maybe<Scalars['Int']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type OrganizationLicenseUsage = {
  __typename?: 'OrganizationLicenseUsage';
  organizationId: Scalars['Int'];
  product: Product;
  productId: Scalars['Int'];
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  siteLicensed: Scalars['Boolean'];
  expiringCount: Scalars['Int'];
  availableCount: Scalars['Int'];
  assignedCount: Scalars['Int'];
  classroomAssignedCount: Scalars['Int'];
  inUseCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  overageStats?: Maybe<OrganizationLicenseUsageOverageStats>;
};

export type OrganizationLicenseUsageOverageStats = {
  __typename?: 'OrganizationLicenseUsageOverageStats';
  availableCount: Scalars['Int'];
  assignedCount: Scalars['Int'];
  expiringCount: Scalars['Int'];
  overageLimitCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export enum OrganizationOrderField {
  ID = 'ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID',
  SOURCE_ID = 'SOURCE_ID',
  NAME = 'NAME',
  ORGANIZATION_TYPE_ID = 'ORGANIZATION_TYPE_ID',
  PARENT_ORGANIZATION_ID = 'PARENT_ORGANIZATION_ID',
}

export type OrganizationPrivilege = {
  __typename?: 'OrganizationPrivilege';
  id: Scalars['Int'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  public: Scalars['Boolean'];
};

export enum OrganizationPrivilegeOrderField {
  ID = 'ID',
  NAME = 'NAME',
}

export type OrganizationPrivilegeWhereInput = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type OrganizationPrivilegesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<OrganizationPrivilegeOrderField>;
};

export type OrganizationPrivilegesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
};

export type OrganizationRole = {
  __typename?: 'OrganizationRole';
  id: Scalars['Int'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  classification: OrganizationRoleClassification;
  appId?: Maybe<Scalars['Int']>;
  app?: Maybe<App>;
  organizationId?: Maybe<Scalars['Int']>;
  organization?: Maybe<Organization>;
  privileges?: Maybe<Array<Maybe<OrganizationPrivilege>>>;
  public: Scalars['Boolean'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export enum OrganizationRoleClassification {
  ADMIN = 'ADMIN',
  FACULTY = 'FACULTY',
  AUDITOR = 'AUDITOR',
}

export enum OrganizationRoleOrderField {
  ID = 'ID',
  NAME = 'NAME',
  APP = 'APP',
  ORGANIZATION = 'ORGANIZATION',
}

export type OrganizationRoleWhereInput = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type OrganizationRolesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<OrganizationRoleOrderField>;
};

export type OrganizationRolesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
  appId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  classification?: Maybe<Array<OrganizationRoleClassification>>;
};

export type OrganizationSetting = {
  __typename?: 'OrganizationSetting';
  id: Scalars['Int'];
  appId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  organizationId: Scalars['Int'];
  setting: Scalars['String'];
  value: Scalars['JSON'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  app?: Maybe<App>;
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  organization: Organization;
};

export enum OrganizationSettingOrderField {
  APP_ID = 'APP_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  SETTING = 'SETTING',
  ORGANIZATION_ID = 'ORGANIZATION_ID',
}

export type OrganizationSettingWhereInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  organizationId: Scalars['Int'];
  setting: Scalars['String'];
};

export type OrganizationSettingsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<OrganizationSettingOrderField>;
};

export type OrganizationSettingsWhereInput = {
  appId?: Maybe<Array<Scalars['Int']>>;
  appName?: Maybe<Array<Scalars['String']>>;
  productId?: Maybe<Array<Scalars['Int']>>;
  productCode?: Maybe<Array<Scalars['String']>>;
  productCurriculumId?: Maybe<Array<Scalars['Int']>>;
  productCurriculumCode?: Maybe<Array<Scalars['String']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  setting?: Maybe<Array<Scalars['String']>>;
};

export type OrganizationStats = {
  __typename?: 'OrganizationStats';
  classroomCount: Scalars['Int'];
  classroomStudentCount: Scalars['Int'];
  classroomUserCount: Scalars['Int'];
  studentCount: Scalars['Int'];
  enrolledStudentCount: Scalars['Int'];
  userCount: Scalars['Int'];
};

export enum OrganizationType {
  USER_GROUP = 'USER_GROUP',
  DEPARTMENT = 'DEPARTMENT',
  SCHOOL = 'SCHOOL',
  DISTRICT = 'DISTRICT',
  LOCAL = 'LOCAL',
  STATE = 'STATE',
  NATIONAL = 'NATIONAL',
}

export type OrganizationUpdateInput = {
  externalId?: Maybe<ExternalIdUpdateInput>;
  sisId?: Maybe<Scalars['String']>;
  ncesId?: Maybe<Scalars['String']>;
  mdrNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<OrganizationType>;
  parentOrganizationId?: Maybe<Scalars['Int']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type OrganizationWhereInput = {
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<ExternalIdInput>;
};

export type OrganizationsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<OrganizationOrderField>;
};

export type OrganizationsUpdateInput = {
  type?: Maybe<OrganizationType>;
  parentOrganizationId?: Maybe<Scalars['Int']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type OrganizationsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  includeRemoved?: Maybe<Scalars['Boolean']>;
  isRootOrganization?: Maybe<Scalars['Boolean']>;
  mdrNumber?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  nsecId?: Maybe<Array<Scalars['String']>>;
  parentOrganization?: Maybe<OrganizationsWhereInput>;
  sisId?: Maybe<Array<Scalars['String']>>;
  sourceId?: Maybe<Array<Scalars['String']>>;
  sourceKind?: Maybe<Array<SourceKind>>;
  type?: Maybe<Array<OrganizationType>>;
  AND?: Maybe<Array<OrganizationsWhereInput>>;
  OR?: Maybe<Array<OrganizationsWhereInput>>;
};

export enum Orientation {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT',
}

export type Page = {
  __typename?: 'Page';
  id: Scalars['Int'];
  bookId: Scalars['Int'];
  pageNumber?: Maybe<Scalars['Int']>;
  src?: Maybe<Scalars['String']>;
  book: Book;
  characters?: Maybe<Array<Character>>;
  tags?: Maybe<Array<PageTag>>;
};

export enum PageLayout {
  DOUBLE_PAGE = 'DOUBLE_PAGE',
  SINGLE_PAGE = 'SINGLE_PAGE',
}

export enum PageOrderField {
  ID = 'ID',
  BOOK_ID = 'BOOK_ID',
  PAGE_NUMBER = 'PAGE_NUMBER',
}

export type PageTag = {
  __typename?: 'PageTag';
  id: Scalars['Int'];
  tag: Scalars['String'];
  value: Scalars['String'];
};

export type PagesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<PageOrderField>;
};

export type PagesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  bookId?: Maybe<Scalars['Int']>;
  pageNumber?: Maybe<Array<Scalars['Int']>>;
  character?: Maybe<CharactersWhereInput>;
};

export type PagingInput = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export enum Placement {
  ABOVE = 'ABOVE',
  BELOW = 'BELOW',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export type Position = {
  __typename?: 'Position';
  offset?: Maybe<Offset>;
  placement?: Maybe<Placement>;
};

export type Product = {
  __typename?: 'Product';
  id: Scalars['Int'];
  code: Scalars['String'];
  name: Scalars['String'];
  type: ProductType;
  gradeLevel?: Maybe<Array<Scalars['String']>>;
  defaultGradeLevel?: Maybe<Array<Scalars['String']>>;
  trialAvailable: Scalars['Boolean'];
  curriculums?: Maybe<Array<ProductCurriculum>>;
  family: ProductFamily;
  iconUrl?: Maybe<Scalars['String']>;
  bannerUrl?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export type ProductBundle = {
  __typename?: 'ProductBundle';
  id: Scalars['Int'];
  code: Scalars['String'];
  name: Scalars['String'];
  products: Array<Maybe<Product>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export enum ProductBundleOrderField {
  ID = 'ID',
  CODE = 'CODE',
  NAME = 'NAME',
  DATE_CREATED = 'DATE_CREATED',
  DATE_UPDATED = 'DATE_UPDATED',
}

export type ProductBundleWhereInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
};

export type ProductBundlesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ProductBundleOrderField>;
};

export type ProductBundlesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  code?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Array<Scalars['String']>>;
};

export type ProductCurriculum = {
  __typename?: 'ProductCurriculum';
  id: Scalars['Int'];
  code: Scalars['String'];
  name: Scalars['String'];
  gradeLevel?: Maybe<Array<Scalars['String']>>;
  defaultGradeLevel?: Maybe<Array<Scalars['String']>>;
  trialAvailable: Scalars['Boolean'];
  productId: Scalars['Int'];
  product?: Maybe<Product>;
  iconUrl?: Maybe<Scalars['String']>;
  bannerUrl?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export enum ProductCurriculumOrderField {
  ID = 'ID',
  CODE = 'CODE',
  NAME = 'NAME',
  TRIAL_AVAILABLE = 'TRIAL_AVAILABLE',
  PRODUCT_ID = 'PRODUCT_ID',
}

export type ProductCurriculumWhereInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
};

export type ProductCurriculumsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ProductCurriculumOrderField>;
};

export type ProductCurriculumsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  code?: Maybe<Array<Scalars['String']>>;
  gradeLevel?: Maybe<Array<Scalars['String']>>;
  trialAvailable?: Maybe<Array<Scalars['Boolean']>>;
  type?: Maybe<Array<ProductType>>;
  product?: Maybe<ProductsWhereInput>;
};

export type ProductFamiliesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ProductFamilyOrderField>;
};

export type ProductFamiliesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  code?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Array<Scalars['String']>>;
  pliManaged?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Array<ProductType>>;
};

export type ProductFamily = {
  __typename?: 'ProductFamily';
  id: Scalars['Int'];
  code: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  products: Array<Maybe<Product>>;
  types: Array<Maybe<ProductType>>;
  iconUrl?: Maybe<Scalars['String']>;
  bannerUrl?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  pliManaged?: Maybe<Scalars['Boolean']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export type ProductFamilyAccessDetails = {
  __typename?: 'ProductFamilyAccessDetails';
  bannerUrl: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  iosUrl?: Maybe<Scalars['String']>;
};

export enum ProductFamilyOrderField {
  ID = 'ID',
  CODE = 'CODE',
  NAME = 'NAME',
}

export type ProductFamilyPurchaseDetails = {
  __typename?: 'ProductFamilyPurchaseDetails';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ProductFamilyWhereInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
};

export type ProductIdentifierInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
};

export enum ProductOrderField {
  ID = 'ID',
  CODE = 'CODE',
  NAME = 'NAME',
  TRIAL_AVAILABLE = 'TRIAL_AVAILABLE',
  PRODUCT_FAMILY_ID = 'PRODUCT_FAMILY_ID',
}

export enum ProductType {
  STUDENT = 'STUDENT',
  USER = 'USER',
}

export type ProductWhereInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
};

export type ProductsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ProductOrderField>;
};

export type ProductsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  code?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Array<Scalars['String']>>;
  gradeLevel?: Maybe<Array<Scalars['String']>>;
  trialAvailable?: Maybe<Array<Scalars['Boolean']>>;
  type?: Maybe<Array<ProductType>>;
  productFamilyId?: Maybe<Array<Scalars['Int']>>;
};

export type ProvisioningResult = {
  __typename?: 'ProvisioningResult';
  success?: Maybe<Array<OrderItemProvisioningResult>>;
  fail?: Maybe<Array<OrderItemProvisioningResult>>;
};

export type Query = {
  __typename?: 'Query';
  _dummyCore?: Maybe<Scalars['Boolean']>;
  apps: Array<Maybe<App>>;
  /**
   * - Required privileges:
   *   - academic-session.read
   */
  academicSession?: Maybe<AcademicSession>;
  /**
   * - Required privileges:
   *   - academic-session.read
   */
  academicSessions: Array<Maybe<AcademicSession>>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  classroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  classrooms?: Maybe<Array<Classroom>>;
  classroomPrivilege?: Maybe<ClassroomPrivilege>;
  classroomPrivileges?: Maybe<Array<Maybe<ClassroomPrivilege>>>;
  classroomRole?: Maybe<ClassroomRole>;
  classroomRoles?: Maybe<Array<Maybe<ClassroomRole>>>;
  /**
   * - Required privileges:
   *   - classroom-setting.read
   */
  classroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - classroom-setting.read
   */
  classroomSettings: Array<Maybe<ClassroomSetting>>;
  /**
   * - Required privileges:
   *   - contact.read
   */
  contact?: Maybe<Contact>;
  /**
   * - Required privileges:
   *   - contact.read
   */
  contacts: Array<Maybe<Contact>>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  enrollment?: Maybe<Enrollment>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  enrollments?: Maybe<Array<Maybe<Enrollment>>>;
  featureToggle?: Maybe<FeatureToggle>;
  featureToggles: Array<Maybe<FeatureToggle>>;
  group?: Maybe<Group>;
  groups: Array<Maybe<Group>>;
  defaultGroupSettings?: Maybe<Array<DefaultGroupSetting>>;
  groupCategory?: Maybe<GroupCategory>;
  groupCategories: Array<Maybe<GroupCategory>>;
  groupEnrollment?: Maybe<GroupEnrollment>;
  groupEnrollments: Array<Maybe<GroupEnrollment>>;
  /**
   * - Required privileges:
   *   - organization.read
   */
  organization?: Maybe<Organization>;
  /**
   * - Required privileges:
   *   - organization.read
   */
  organizations: Array<Maybe<Organization>>;
  organizationPrivilege?: Maybe<OrganizationPrivilege>;
  organizationPrivileges?: Maybe<Array<Maybe<OrganizationPrivilege>>>;
  organizationRole?: Maybe<OrganizationRole>;
  organizationRoles?: Maybe<Array<Maybe<OrganizationRole>>>;
  organizationSetting?: Maybe<OrganizationSetting>;
  organizationSettings: Array<Maybe<OrganizationSetting>>;
  product?: Maybe<Product>;
  products: Array<Maybe<Product>>;
  productBundle?: Maybe<ProductBundle>;
  productBundles: Array<Maybe<ProductBundle>>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculums: Array<ProductCurriculum>;
  productFamily?: Maybe<ProductFamily>;
  productFamilies: Array<Maybe<ProductFamily>>;
  /**
   * - Required privileges:
   *   - student.read
   */
  student?: Maybe<Student>;
  /**
   * - Required privileges:
   *   - student.read
   */
  students: Array<Maybe<Student>>;
  /**
   * - Required privileges:
   *   - student.read
   */
  studentSearch: Array<Student>;
  /**
   * - Required privileges:
   *   - student-setting.read
   */
  studentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student-setting.read
   */
  studentSettings: Array<Maybe<StudentSetting>>;
  tour?: Maybe<Tour>;
  tours: Array<Maybe<Tour>>;
  toursSettings: Array<Maybe<TourSettings>>;
  tourStep?: Maybe<TourStep>;
  tourSteps: Array<Maybe<TourStep>>;
  me?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user.read
   */
  user?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user.read
   */
  users: Array<User>;
  /**
   * - Required privileges:
   *   - user.read
   */
  userSearch: Array<User>;
  /**
   * - Required privileges:
   *   - user-setting.read
   */
  userSetting?: Maybe<UserSetting>;
  /**
   * - Required privileges:
   *   - user-setting.read
   */
  userSettings: Array<Maybe<UserSetting>>;
  _dummyFulfillment?: Maybe<Scalars['Boolean']>;
  mastercode?: Maybe<Mastercode>;
  mastercodes?: Maybe<Array<Mastercode>>;
  mastercodeTransferHistory?: Maybe<MastercodeTransferHistory>;
  mastercodeTransferHistories?: Maybe<Array<MastercodeTransferHistory>>;
  order?: Maybe<Order>;
  orders?: Maybe<Array<Order>>;
  _dummyLicenseManager?: Maybe<Scalars['Boolean']>;
  license?: Maybe<License>;
  licenses: Array<Maybe<License>>;
  availableLicenses: Array<Maybe<License>>;
  siteLicense?: Maybe<SiteLicense>;
  siteLicenses: Array<Maybe<SiteLicense>>;
  affirmations: Array<Maybe<Asset>>;
  assignment?: Maybe<Assignment>;
  assignmentList: AssignmentList;
  book?: Maybe<Book>;
  bookList: BookList;
  bookContent: Array<Maybe<BookContent>>;
  feelingsMatch?: Maybe<FeelingsMatchActivity>;
  findTheLetter?: Maybe<FindTheLetterActivity>;
  findTheObjects?: Maybe<FindTheObjectsActivity>;
  guessTheOrder?: Maybe<GuessTheOrderActivity>;
  guessWhere?: Maybe<GuessWhereActivity>;
  guessWho?: Maybe<GuessWhoActivity>;
  matchItTrashIt?: Maybe<MatchItTrashItActivity>;
  pages: Array<Maybe<Page>>;
  studentProgress: StudentProgress;
  readAloud?: Maybe<ReadAloudActivity>;
  readStory?: Maybe<ReadStoryActivity>;
  readingLog?: Maybe<ReadingLog>;
  readingLogs: Array<Maybe<ReadingLog>>;
  resources: Array<Maybe<Resource>>;
  resourceTypes: Array<Maybe<ResourceType>>;
  startingSound?: Maybe<StartingSoundActivity>;
  studentRewards?: Maybe<StudentRewards>;
  studentSession?: Maybe<StudentSession>;
  wetDryTry?: Maybe<WetDryTryActivity>;
};

export type QueryAcademicSessionArgs = {
  where: AcademicSessionWhereInput;
};

export type QueryAcademicSessionsArgs = {
  where?: Maybe<AcademicSessionsWhereInput>;
  orderBy?: Maybe<AcademicSessionsOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryClassroomArgs = {
  where: ClassroomWhereInput;
};

export type QueryClassroomsArgs = {
  where?: Maybe<ClassroomsWhereInput>;
  whereUser?: Maybe<UsersWhereInput>;
  orderBy?: Maybe<ClassroomsOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryClassroomPrivilegeArgs = {
  where: ClassroomPrivilegeWhereInput;
};

export type QueryClassroomPrivilegesArgs = {
  where?: Maybe<ClassroomPrivilegesWhereInput>;
  orderBy?: Maybe<ClassroomPrivilegesOrderInput>;
};

export type QueryClassroomRoleArgs = {
  where: ClassroomRoleWhereInput;
};

export type QueryClassroomRolesArgs = {
  where?: Maybe<ClassroomRolesWhereInput>;
  orderBy?: Maybe<ClassroomRolesOrderInput>;
};

export type QueryClassroomSettingArgs = {
  where: ClassroomSettingWhereInput;
};

export type QueryClassroomSettingsArgs = {
  where?: Maybe<ClassroomSettingsWhereInput>;
  orderBy?: Maybe<ClassroomSettingsOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryContactArgs = {
  where: ContactWhereInput;
};

export type QueryContactsArgs = {
  where?: Maybe<ContactsWhereInput>;
  orderBy?: Maybe<ContactsOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryEnrollmentArgs = {
  where: EnrollmentWhereInput;
};

export type QueryEnrollmentsArgs = {
  where?: Maybe<EnrollmentsWhereInput>;
  orderBy?: Maybe<EnrollmentsOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryFeatureToggleArgs = {
  where: FeatureToggleWhereInput;
};

export type QueryFeatureTogglesArgs = {
  where?: Maybe<FeatureTogglesWhereInput>;
  orderBy?: Maybe<FeatureTogglesOrderInput>;
};

export type QueryGroupArgs = {
  where: GroupWhereInput;
};

export type QueryGroupsArgs = {
  where: GroupsWhereInput;
  orderBy?: Maybe<GroupsOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryGroupCategoryArgs = {
  where: GroupCategoryWhereInput;
};

export type QueryGroupCategoriesArgs = {
  where: GroupCategoriesWhereInput;
  orderBy?: Maybe<GroupCategoriesOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryGroupEnrollmentArgs = {
  where: GroupEnrollmentWhereInput;
};

export type QueryGroupEnrollmentsArgs = {
  where: GroupEnrollmentsWhereInput;
  orderBy?: Maybe<GroupEnrollmentsOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryOrganizationArgs = {
  where: OrganizationWhereInput;
};

export type QueryOrganizationsArgs = {
  where?: Maybe<OrganizationsWhereInput>;
  whereUserOrganization?: Maybe<UserOrganizationInput>;
  orderBy?: Maybe<OrganizationsOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryOrganizationPrivilegeArgs = {
  where: OrganizationPrivilegeWhereInput;
};

export type QueryOrganizationPrivilegesArgs = {
  where?: Maybe<OrganizationPrivilegesWhereInput>;
  orderBy?: Maybe<OrganizationPrivilegesOrderInput>;
};

export type QueryOrganizationRoleArgs = {
  where: OrganizationRoleWhereInput;
};

export type QueryOrganizationRolesArgs = {
  where?: Maybe<OrganizationRolesWhereInput>;
  orderBy?: Maybe<OrganizationRolesOrderInput>;
};

export type QueryOrganizationSettingArgs = {
  where: OrganizationSettingWhereInput;
};

export type QueryOrganizationSettingsArgs = {
  where?: Maybe<OrganizationSettingsWhereInput>;
  orderBy?: Maybe<OrganizationSettingsOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryProductArgs = {
  where: ProductWhereInput;
};

export type QueryProductsArgs = {
  where?: Maybe<ProductsWhereInput>;
  orderBy?: Maybe<ProductsOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryProductBundleArgs = {
  where: ProductBundleWhereInput;
};

export type QueryProductBundlesArgs = {
  where?: Maybe<ProductBundlesWhereInput>;
  orderBy?: Maybe<ProductBundlesOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryProductCurriculumArgs = {
  where: ProductCurriculumWhereInput;
};

export type QueryProductCurriculumsArgs = {
  where?: Maybe<ProductCurriculumsWhereInput>;
  orderBy?: Maybe<ProductCurriculumsOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryProductFamilyArgs = {
  where: ProductFamilyWhereInput;
};

export type QueryProductFamiliesArgs = {
  where?: Maybe<ProductFamiliesWhereInput>;
  orderBy?: Maybe<ProductFamiliesOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryStudentArgs = {
  where: StudentWhereInput;
};

export type QueryStudentsArgs = {
  where?: Maybe<StudentsWhereInput>;
  orderBy?: Maybe<StudentsOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryStudentSearchArgs = {
  searchText: Scalars['String'];
  searchFields?: Maybe<Array<StudentSearchField>>;
  classroomId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  where?: Maybe<StudentsWhereInput>;
  orderBy?: Maybe<StudentsOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryStudentSettingArgs = {
  where: StudentSettingWhereInput;
};

export type QueryStudentSettingsArgs = {
  where?: Maybe<StudentSettingsWhereInput>;
  orderBy?: Maybe<StudentSettingsOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryTourArgs = {
  where: TourWhereInput;
};

export type QueryToursArgs = {
  where: ToursWhereInput;
  orderBy?: Maybe<ToursOrderInput>;
};

export type QueryToursSettingsArgs = {
  where: ToursSettingsWhereInput;
};

export type QueryTourStepArgs = {
  where: TourStepWhereInput;
};

export type QueryTourStepsArgs = {
  where: TourStepsWhereInput;
};

export type QueryUserArgs = {
  where: UserWhereInput;
};

export type QueryUsersArgs = {
  where?: Maybe<UsersWhereInput>;
  orderBy?: Maybe<UsersOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryUserSearchArgs = {
  searchText: Scalars['String'];
  searchFields?: Maybe<Array<UserSearchField>>;
  classroomId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  where?: Maybe<UsersWhereInput>;
  orderBy?: Maybe<UsersOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryUserSettingArgs = {
  where: UserSettingWhereInput;
};

export type QueryUserSettingsArgs = {
  where?: Maybe<UserSettingsWhereInput>;
  orderBy?: Maybe<UserSettingsOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryMastercodeArgs = {
  where: MastercodeWhereInput;
};

export type QueryMastercodesArgs = {
  where: MastercodesWhereInput;
  orderBy?: Maybe<MastercodesOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryMastercodeTransferHistoryArgs = {
  where: MastercodeTransferHistoryWhereInput;
};

export type QueryMastercodeTransferHistoriesArgs = {
  where: MastercodeTransferHistoriesWhereInput;
  orderBy?: Maybe<MastercodeTransferHistoryOrderInput>;
};

export type QueryOrderArgs = {
  where: OrderWhereInput;
};

export type QueryOrdersArgs = {
  where?: Maybe<OrdersWhereInput>;
  orderBy?: Maybe<OrdersOrderInput>;
  paging?: Maybe<PagingInput>;
  mastercodeWhere?: Maybe<MastercodesWhereInput>;
};

export type QueryLicenseArgs = {
  where: LicenseWhereInput;
};

export type QueryLicensesArgs = {
  where?: Maybe<LicensesWhereInput>;
  orderBy?: Maybe<LicensesOrderInput>;
  paging?: Maybe<PagingInput>;
};

export type QueryAvailableLicensesArgs = {
  where: FindAvailableLicenseWhereInput;
};

export type QuerySiteLicenseArgs = {
  where: SiteLicenseWhereInput;
};

export type QuerySiteLicensesArgs = {
  where?: Maybe<SiteLicensesWhereInput>;
  orderBy?: Maybe<SiteLicensesOrderInput>;
};

export type QueryAffirmationsArgs = {
  where?: Maybe<AffirmationsWhereInput>;
};

export type QueryAssignmentArgs = {
  where: AssignmentWhereInput;
};

export type QueryAssignmentListArgs = {
  where?: Maybe<AssignmentListWhereInput>;
  orderBy?: Maybe<AssignmentListOrderInput>;
};

export type QueryBookArgs = {
  where: BookWhereInput;
};

export type QueryBookListArgs = {
  where?: Maybe<BookListWhereInput>;
  orderBy?: Maybe<BookListOrderInput>;
};

export type QueryBookContentArgs = {
  where?: Maybe<BookWhereInput>;
};

export type QueryFeelingsMatchArgs = {
  where: ActivityWhereInput;
};

export type QueryFindTheLetterArgs = {
  where: ReadActivityWhereInput;
};

export type QueryFindTheObjectsArgs = {
  where: ReadActivityWhereInput;
};

export type QueryGuessTheOrderArgs = {
  where: ActivityWhereInput;
};

export type QueryGuessWhereArgs = {
  where: ActivityWhereInput;
};

export type QueryGuessWhoArgs = {
  where: ActivityWhereInput;
};

export type QueryMatchItTrashItArgs = {
  where: ActivityWhereInput;
};

export type QueryPagesArgs = {
  where: PagesWhereInput;
  orderBy?: Maybe<PagesOrderInput>;
};

export type QueryStudentProgressArgs = {
  where: StudentProgressDataWhereInput;
};

export type QueryReadAloudArgs = {
  where: ReadActivityWhereInput;
};

export type QueryReadStoryArgs = {
  where: ReadActivityWhereInput;
};

export type QueryReadingLogArgs = {
  where: ReadingLogWhereInput;
};

export type QueryReadingLogsArgs = {
  where: ReadingLogsWhereInput;
};

export type QueryResourcesArgs = {
  where?: Maybe<ResourcesWhereInput>;
  orderBy?: Maybe<ResourcesOrderInput>;
};

export type QueryResourceTypesArgs = {
  where?: Maybe<ResourceTypesWhereInput>;
  orderBy?: Maybe<ResourceTypesOrderInput>;
};

export type QueryStartingSoundArgs = {
  where: ActivityWhereInput;
};

export type QueryStudentRewardsArgs = {
  where: StudentRewardsWhereInput;
};

export type QueryWetDryTryArgs = {
  where: ActivityWhereInput;
};

export type ReadActivityWhereInput = {
  id?: Maybe<Scalars['Int']>;
  book?: Maybe<BookWhereInput>;
  pages?: Maybe<PagesWhereInput>;
};

export type ReadAloudActivity = IActivity & {
  __typename?: 'ReadAloudActivity';
  id: Scalars['Int'];
  activityTypeId: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  instructions: Asset;
  bookId: Scalars['Int'];
  book?: Maybe<Book>;
  activityType?: Maybe<ActivityType>;
  pages: Array<ReadAloudPage>;
};

export type ReadAloudPage = {
  __typename?: 'ReadAloudPage';
  pageId: Scalars['Int'];
  page?: Maybe<Page>;
  contents?: Maybe<Array<Maybe<Asset>>>;
};

export type ReadBookEventCreateInput = {
  timestamp: Scalars['DateTime'];
  bookId: Scalars['Int'];
  bookCode: Scalars['String'];
  bookType: BookType;
  activityType: Scalars['String'];
  word?: Maybe<WordInput>;
  pageId: Scalars['Int'];
  pageNumber: Scalars['String'];
  pageLayout: PageLayout;
  section: ApplicationSection;
  character: CharacterInput;
};

export type ReadStoryActivity = IActivity & {
  __typename?: 'ReadStoryActivity';
  id: Scalars['Int'];
  activityTypeId: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  instructions: Asset;
  bookId: Scalars['Int'];
  book?: Maybe<Book>;
  activityType?: Maybe<ActivityType>;
  pages: Array<ReadStoryPage>;
};

export type ReadStoryPage = {
  __typename?: 'ReadStoryPage';
  pageId: Scalars['Int'];
  page?: Maybe<Page>;
  words?: Maybe<Array<Maybe<Asset>>>;
};

export type ReadingLog = {
  __typename?: 'ReadingLog';
  id: Scalars['Int'];
  bookId: Scalars['Int'];
  studentId: Scalars['Int'];
  pagesRead: Scalars['Int'];
  dateStarted: Scalars['DateTime'];
  dateCompleted: Scalars['DateTime'];
  bookCompleted?: Maybe<Scalars['Boolean']>;
  book: Book;
  studentReward?: Maybe<StudentReward>;
};

export type ReadingLogWhereInput = {
  id?: Maybe<Scalars['Int']>;
  bookId?: Maybe<Scalars['Int']>;
};

export type ReadingLogsWhereInput = {
  bookId?: Maybe<Array<Scalars['Int']>>;
};

export type Resource = {
  __typename?: 'Resource';
  id: Scalars['Int'];
  resourceTypeId: Scalars['Int'];
  title: Scalars['String'];
  thumbnail: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  asset?: Maybe<Asset>;
  type: ResourceType;
  tags?: Maybe<Array<ResourceTag>>;
  resourceProducts: Array<ResourceProduct>;
  characters: Array<Character>;
};

export enum ResourceOrderField {
  ID = 'ID',
  TITLE = 'TITLE',
  RESOURCE_TYPE_ID = 'RESOURCE_TYPE_ID',
}

export type ResourceProduct = {
  __typename?: 'ResourceProduct';
  id: Scalars['Int'];
  resourceId: Scalars['Int'];
  productId: Scalars['Int'];
  resource: Resource;
  product: Product;
};

export type ResourceTag = {
  __typename?: 'ResourceTag';
  id: Scalars['Int'];
  tag: Scalars['String'];
  value: Scalars['String'];
};

export type ResourceType = {
  __typename?: 'ResourceType';
  id: Scalars['Int'];
  type: Scalars['String'];
  title: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
};

export enum ResourceTypeOrderField {
  ID = 'ID',
  TITLE = 'TITLE',
  SORT_INDEX = 'SORT_INDEX',
}

export type ResourceTypesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ResourceTypeOrderField>;
};

export type ResourceTypesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  type?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Array<Scalars['String']>>;
  locale?: Maybe<Array<Locale>>;
};

export type ResourcesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ResourceOrderField>;
};

export type ResourcesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  resourceTypeId?: Maybe<Array<Scalars['Int']>>;
  character?: Maybe<CharactersWhereInput>;
};

export type Reward = {
  __typename?: 'Reward';
  id: Scalars['Int'];
  characterId: Scalars['Int'];
  assetId: Scalars['Int'];
  audioId: Scalars['Int'];
  character: Character;
  asset: Asset;
  audio: Asset;
};

export enum RouteSource {
  DASHBOARD = 'DASHBOARD',
  ASSIGNMENTS = 'ASSIGNMENTS',
}

export type SaveAttemptInput = {
  assignmentActivityId: Scalars['Int'];
  status?: Maybe<AttemptStatus>;
  dateStarted?: Maybe<Scalars['DateTime']>;
  dateCompleted?: Maybe<Scalars['DateTime']>;
};

export type SaveTourSettingsInput = {
  tourId: Scalars['Int'];
  tourStepSettings: Array<SaveTourStepSettingInput>;
};

export type SaveTourStepSettingInput = {
  tourStepId: Scalars['Int'];
  viewed: Scalars['Boolean'];
};

export type SaveToursSettingsInput = {
  userId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  toursSettings: Array<SaveTourSettingsInput>;
};

export type SelectStudentRewardInput = {
  id: Scalars['Int'];
};

export type SiteLicense = {
  __typename?: 'SiteLicense';
  id: Scalars['Int'];
  licenseRangeMin: Scalars['Int'];
  licenseRangeMax: Scalars['Int'];
  licenseType: LicenseType;
  orderItemId: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  ownerUser?: Maybe<User>;
  ownerUserId: Scalars['Int'];
  productFamily?: Maybe<ProductFamily>;
  productFamilyId: Scalars['Int'];
  dateExpiration: Scalars['DateTime'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export enum SiteLicenseOrderField {
  ID = 'ID',
  DATE_CREATED = 'DATE_CREATED',
  DATE_EXPIRATION = 'DATE_EXPIRATION',
  DATE_UPDATED_ASSIGNMENT = 'DATE_UPDATED_ASSIGNMENT',
  DATE_UPDATED = 'DATE_UPDATED',
  PRODUCT_ID = 'PRODUCT_ID',
}

export type SiteLicenseUpdateInput = {
  dateExpiration?: Maybe<Scalars['DateTime']>;
  orderItemId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

export type SiteLicenseWhereInput = {
  id: Scalars['Int'];
};

export type SiteLicensesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<SiteLicenseOrderField>;
};

export type SiteLicensesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  expired?: Maybe<Scalars['Boolean']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  productFamily?: Maybe<Array<ProductIdentifierInput>>;
  ownerUserId?: Maybe<Array<Scalars['Int']>>;
};

export enum SourceKind {
  ONE_ROSTER = 'ONE_ROSTER',
  CLEVER = 'CLEVER',
  CLASS_LINK = 'CLASS_LINK',
  GOOGLE = 'GOOGLE',
  FIREBASE = 'FIREBASE',
  ONE_ROSTER_API = 'ONE_ROSTER_API',
  ONE_ROSTER_NYCPS = 'ONE_ROSTER_NYCPS',
}

export type StartingSoundActivity = LiteRouteActivity & {
  __typename?: 'StartingSoundActivity';
  id: Scalars['Int'];
  activityTypeId: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  bookId: Scalars['Int'];
  url: Scalars['String'];
  book?: Maybe<Book>;
  activityType?: Maybe<ActivityType>;
};

export enum StoryElementOrder {
  BEGINNING = 'BEGINNING',
  MIDDLE = 'MIDDLE',
  END = 'END',
}

export type Student = {
  __typename?: 'Student';
  id: Scalars['Int'];
  externalId?: Maybe<ExternalId>;
  sisId?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  loginType: StudentLoginType;
  password?: Maybe<Scalars['String']>;
  gradeLevel: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  classrooms?: Maybe<Array<Classroom>>;
  contacts?: Maybe<Array<Contact>>;
  status?: Maybe<StudentStatus>;
  settings?: Maybe<Array<StudentSetting>>;
  toursSettings?: Maybe<Array<TourSettings>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  groups?: Maybe<Array<Group>>;
  licenses?: Maybe<Array<License>>;
  licenseUsage?: Maybe<Array<StudentLicenseUsage>>;
  locale?: Maybe<Locale>;
};

export type StudentSettingsArgs = {
  where?: Maybe<StudentSettingsWhereInput>;
  orderBy?: Maybe<StudentSettingsOrderInput>;
};

export type StudentToursSettingsArgs = {
  where?: Maybe<ToursSettingsWhereInput>;
};

export type StudentGroupsArgs = {
  where?: Maybe<GroupsWhereInput>;
  orderBy?: Maybe<GroupsOrderInput>;
};

export type StudentLicensesArgs = {
  where?: Maybe<LicensesWhereInput>;
  orderBy?: Maybe<LicensesOrderInput>;
};

export type StudentLicenseUsageArgs = {
  where?: Maybe<LicenseUsageWhereInput>;
};

export type StudentContact = {
  __typename?: 'StudentContact';
  studentId: Scalars['Int'];
  contactId: Scalars['Int'];
};

export type StudentCreateInput = {
  externalId?: Maybe<ExternalIdInput>;
  sisId?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  loginType?: Maybe<StudentLoginType>;
  password?: Maybe<Scalars['String']>;
  gradeLevel: Scalars['String'];
  organizationId: Scalars['Int'];
  classroomId?: Maybe<Array<Scalars['Int']>>;
  licenses?: Maybe<Array<CreateEntityLicenseAssignInput>>;
  settings?: Maybe<Array<BaseSettingCreateInput>>;
  group?: Maybe<Array<GroupUpsertInput>>;
};

export type StudentLicenseUsage = {
  __typename?: 'StudentLicenseUsage';
  product: Product;
  productId: Scalars['Int'];
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  assignedCount: Scalars['Int'];
  active: Scalars['Boolean'];
  manualAssignment: Scalars['Boolean'];
  trial: Scalars['Boolean'];
};

export enum StudentLoginType {
  LETTER_CARDS = 'LETTER_CARDS',
  TEXTBOX = 'TEXTBOX',
}

export type StudentProgress = {
  __typename?: 'StudentProgress';
  studentId: Scalars['Int'];
  student?: Maybe<Student>;
  characterProgress: Array<CharacterProgress>;
};

export type StudentProgressDataWhereInput = {
  characterIds: Array<Scalars['Int']>;
};

export type StudentReward = {
  __typename?: 'StudentReward';
  id: Scalars['Int'];
  studentId: Scalars['Int'];
  characterId: Scalars['Int'];
  rewardId: Scalars['Int'];
  selected: Scalars['Boolean'];
  character: Character;
  reward: Reward;
};

export type StudentRewards = {
  __typename?: 'StudentRewards';
  studentId: Scalars['Int'];
  student: Student;
  instructions: Asset;
  characterRewards: Array<Maybe<CharacterRewards>>;
};

export type StudentRewardsWhereInput = {
  character: CharacterWhereInput;
};

export enum StudentSearchField {
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
}

export type StudentSession = {
  __typename?: 'StudentSession';
  sessionId: Scalars['String'];
  student: Student;
};

export type StudentSetting = {
  __typename?: 'StudentSetting';
  id: Scalars['Int'];
  appId: Scalars['Int'];
  productId?: Maybe<Scalars['Int']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  studentId: Scalars['Int'];
  setting: Scalars['String'];
  value: Scalars['JSON'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  app: App;
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  student: Student;
};

export type StudentSettingCreateInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  studentId: Scalars['Int'];
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export enum StudentSettingOrderField {
  APP_ID = 'APP_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  SETTING = 'SETTING',
  STUDENT_ID = 'STUDENT_ID',
}

export type StudentSettingUpdateInput = {
  setting?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['JSON']>;
};

export type StudentSettingWhereInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  studentId: Scalars['Int'];
  setting: Scalars['String'];
};

export type StudentSettingsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<StudentSettingOrderField>;
};

export type StudentSettingsUpdateInput = {
  setting?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['JSON']>;
};

export type StudentSettingsWhereInput = {
  appId?: Maybe<Array<Scalars['Int']>>;
  appName?: Maybe<Array<Scalars['String']>>;
  productId?: Maybe<Array<Scalars['Int']>>;
  productCode?: Maybe<Array<Scalars['String']>>;
  productCurriculumId?: Maybe<Array<Scalars['Int']>>;
  productCurriculumCode?: Maybe<Array<Scalars['String']>>;
  studentId?: Maybe<Array<Scalars['Int']>>;
  setting?: Maybe<Array<Scalars['String']>>;
};

export enum StudentStatus {
  ACTIVE = 'ACTIVE',
  REMOVED = 'REMOVED',
}

export type StudentUpdateInput = {
  externalId?: Maybe<ExternalIdInput>;
  sisId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  loginType?: Maybe<StudentLoginType>;
  password?: Maybe<Scalars['String']>;
  gradeLevel?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
  groups?: Maybe<Array<GroupUpsertInput>>;
};

export type StudentWhereInput = {
  externalId?: Maybe<ExternalIdInput>;
  id?: Maybe<Scalars['Int']>;
  authToken?: Maybe<Scalars['String']>;
};

export enum StudentsOrderField {
  ID = 'ID',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID',
  USERNAME = 'USERNAME',
  PASSWORD = 'PASSWORD',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  GRADE_LEVEL = 'GRADE_LEVEL',
}

export type StudentsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<StudentsOrderField>;
};

export type StudentsUpdateInput = {
  loginType?: Maybe<StudentLoginType>;
  gradeLevel?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type StudentsWhereInput = {
  id?: Maybe<Array<Maybe<Scalars['Int']>>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  sourceId?: Maybe<Array<Scalars['String']>>;
  sourceKind?: Maybe<Array<SourceKind>>;
  authToken?: Maybe<Array<Scalars['String']>>;
  firstName?: Maybe<Array<Scalars['String']>>;
  firstName_contains?: Maybe<Scalars['String']>;
  lastName?: Maybe<Array<Scalars['String']>>;
  lastName_contains?: Maybe<Scalars['String']>;
  email?: Maybe<Array<Scalars['String']>>;
  email_contains?: Maybe<Scalars['String']>;
  gradeLevel?: Maybe<Array<Scalars['String']>>;
  username?: Maybe<Array<Scalars['String']>>;
  username_contains?: Maybe<Scalars['String']>;
  organizations?: Maybe<OrganizationsWhereInput>;
  classrooms?: Maybe<ClassroomsWhereInput>;
  includeRemoved?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Array<StudentStatus>>;
  AND?: Maybe<Array<StudentsWhereInput>>;
  OR?: Maybe<Array<StudentsWhereInput>>;
};

export type SwapLicensesInput = {
  toProductId: Scalars['Int'];
};

export type SwapLicensesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Scalars['Int']>;
  fromProductId?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  expiresAfter?: Maybe<Scalars['DateTime']>;
};

export type Tour = {
  __typename?: 'Tour';
  id: Scalars['Int'];
  appId: Scalars['Int'];
  productId?: Maybe<Scalars['Int']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  tourSteps: Array<TourStep>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  app: App;
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
};

export enum TourOrderField {
  ID = 'ID',
  APP_ID = 'APP_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  NAME = 'NAME',
}

export type TourSettings = {
  __typename?: 'TourSettings';
  tourId: Scalars['Int'];
  tour?: Maybe<Tour>;
  tourStepSettings: Array<TourStepSetting>;
};

export type TourStep = {
  __typename?: 'TourStep';
  id: Scalars['Int'];
  tourId: Scalars['Int'];
  name: Scalars['String'];
  title: Scalars['String'];
  groupName?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['Int']>;
  media?: Maybe<Media>;
  position?: Maybe<Position>;
  data?: Maybe<Scalars['JSON']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  tour: Tour;
};

export type TourStepSetting = {
  __typename?: 'TourStepSetting';
  tourStepId: Scalars['Int'];
  tourStep?: Maybe<TourStep>;
  viewed: Scalars['Boolean'];
};

export type TourStepWhereInput = {
  id?: Maybe<Scalars['Int']>;
  tourId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type TourStepsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  tourId?: Maybe<Array<Scalars['Int']>>;
};

export type TourWhereInput = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
};

export type ToursOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<TourOrderField>;
};

export type ToursSettingsWhereInput = {
  userId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Array<Scalars['Int']>>;
  productCode?: Maybe<Array<Scalars['String']>>;
  productCurriculumId?: Maybe<Array<Scalars['Int']>>;
  productCurriculumCode?: Maybe<Array<Scalars['String']>>;
  tours?: Maybe<Array<Scalars['String']>>;
  toursSteps?: Maybe<Array<Scalars['String']>>;
  viewed?: Maybe<Scalars['Boolean']>;
};

export type ToursWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
  appId?: Maybe<Array<Scalars['Int']>>;
  appName?: Maybe<Array<Scalars['String']>>;
  productId?: Maybe<Array<Scalars['Int']>>;
  productCode?: Maybe<Array<Scalars['String']>>;
  productCurriculumId?: Maybe<Array<Scalars['Int']>>;
  productCurriculumCode?: Maybe<Array<Scalars['String']>>;
};

export type TransferStudentInput = {
  fromClassroomId: Scalars['Int'];
  toClassroomId: Scalars['Int'];
};

export type TransferStudentWhereInput = {
  studentId: Scalars['Int'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['Int'];
  externalId?: Maybe<ExternalId>;
  sisId?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  type: UserType;
  userTypeId: Scalars['Int'];
  pin: Scalars['String'];
  avatarUrl?: Maybe<Scalars['String']>;
  azureId?: Maybe<Scalars['String']>;
  status: UserStatus;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  classroomPrivileges?: Maybe<Array<UserClassroomPrivileges>>;
  classroomEnrollments?: Maybe<Array<UserClassroomEnrollment>>;
  organizationPrivileges?: Maybe<Array<UserOrganizationPrivileges>>;
  organizationAssociations?: Maybe<Array<UserOrganization>>;
  settings?: Maybe<Array<UserSetting>>;
  toursSettings?: Maybe<Array<TourSettings>>;
  mastercodes?: Maybe<Array<Mastercode>>;
  orders?: Maybe<Array<Order>>;
  licenses?: Maybe<Array<License>>;
  licenseUsage?: Maybe<Array<UserLicenseUsage>>;
  trialUsage?: Maybe<Array<UserTrialUsage>>;
};

export type UserSettingsArgs = {
  where?: Maybe<UserSettingsWhereInput>;
  orderBy?: Maybe<UserSettingsOrderInput>;
};

export type UserToursSettingsArgs = {
  where?: Maybe<ToursSettingsWhereInput>;
};

export type UserMastercodesArgs = {
  where?: Maybe<MastercodesWhereInput>;
  orderBy?: Maybe<MastercodesOrderInput>;
};

export type UserOrdersArgs = {
  where?: Maybe<OrdersWhereInput>;
  orderBy?: Maybe<OrdersOrderInput>;
};

export type UserLicensesArgs = {
  where?: Maybe<LicensesWhereInput>;
  orderBy?: Maybe<LicensesOrderInput>;
};

export type UserLicenseUsageArgs = {
  where?: Maybe<UserLicenseUsageWhereInput>;
};

export type UserTrialUsageArgs = {
  where?: Maybe<UserLicenseUsageWhereInput>;
};

export type UserClassroomEnrollment = {
  __typename?: 'UserClassroomEnrollment';
  classroom: Classroom;
  classroomId: Scalars['Int'];
  classroomRoles: Array<ClassroomRole>;
  classroomRoleIds: Array<Scalars['Int']>;
  user: User;
  userId: Scalars['Int'];
};

export type UserClassroomPrivileges = {
  __typename?: 'UserClassroomPrivileges';
  classroomId: Scalars['Int'];
  privileges?: Maybe<Array<Scalars['String']>>;
};

export type UserCreateInput = {
  externalId?: Maybe<ExternalIdInput>;
  sisId?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  type?: Maybe<UserType>;
  pin?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  status?: Maybe<UserStatus>;
  organizationAssociations?: Maybe<Array<UserOrganizationInput>>;
  licenses?: Maybe<Array<CreateEntityLicenseAssignInput>>;
  settings?: Maybe<Array<BaseSettingCreateInput>>;
};

export type UserEnrollmentInput = {
  userId: Scalars['Int'];
  classroomRole?: Maybe<Array<UserRole>>;
};

export type UserLicenseUsage = {
  __typename?: 'UserLicenseUsage';
  product: Product;
  productId: Scalars['Int'];
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  assignedCount: Scalars['Int'];
  manualAssignment: Scalars['Boolean'];
  active: Scalars['Boolean'];
  trial: Scalars['Boolean'];
};

export type UserLicenseUsageWhereInput = {
  includeExpired?: Maybe<Scalars['Boolean']>;
  product?: Maybe<Array<ProductIdentifierInput>>;
  productCurriculum?: Maybe<Array<ProductIdentifierInput>>;
  productFamily?: Maybe<Array<ProductIdentifierInput>>;
};

export enum UserOrderField {
  ID = 'ID',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID',
  USERNAME = 'USERNAME',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
}

export type UserOrganization = {
  __typename?: 'UserOrganization';
  organization: Organization;
  organizationId: Scalars['Int'];
  organizationRoles: Array<OrganizationRole>;
  organizationRoleIds: Array<Scalars['Int']>;
  user: User;
  userId: Scalars['Int'];
};

export type UserOrganizationInput = {
  organizationId: Scalars['Int'];
  organizationRoleId: Array<Scalars['Int']>;
};

export type UserOrganizationPrivileges = {
  __typename?: 'UserOrganizationPrivileges';
  organizationId: Scalars['Int'];
  privileges?: Maybe<Array<Scalars['String']>>;
};

export type UserOrganizationWhereInput = {
  excludeAncestors?: Maybe<Scalars['Boolean']>;
};

export enum UserRole {
  EDUCATOR = 'EDUCATOR',
  EDUCATOR_GSS = 'EDUCATOR_GSS',
  EDUCATOR_KEY = 'EDUCATOR_KEY',
  COEDUCATOR = 'COEDUCATOR',
  COEDUCATOR_GSS = 'COEDUCATOR_GSS',
  COEDUCATOR_KEY = 'COEDUCATOR_KEY',
}

export enum UserSearchField {
  USERNAME = 'USERNAME',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
}

export type UserSetting = {
  __typename?: 'UserSetting';
  id: Scalars['Int'];
  appId: Scalars['Int'];
  productId?: Maybe<Scalars['Int']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  userId: Scalars['Int'];
  setting: Scalars['String'];
  value: Scalars['JSON'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  app: App;
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  user: User;
};

export type UserSettingCreateInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export enum UserSettingOrderField {
  APP_ID = 'APP_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  SETTING = 'SETTING',
  USER_ID = 'USER_ID',
}

export type UserSettingUpdateInput = {
  setting?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['JSON']>;
};

export type UserSettingWhereInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
  setting: Scalars['String'];
};

export type UserSettingsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<UserSettingOrderField>;
};

export type UserSettingsUpdateInput = {
  setting?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['JSON']>;
};

export type UserSettingsWhereInput = {
  appId?: Maybe<Array<Scalars['Int']>>;
  appName?: Maybe<Array<Scalars['String']>>;
  productId?: Maybe<Array<Scalars['Int']>>;
  productCode?: Maybe<Array<Scalars['String']>>;
  productCurriculumId?: Maybe<Array<Scalars['Int']>>;
  productCurriculumCode?: Maybe<Array<Scalars['String']>>;
  userId?: Maybe<Array<Scalars['Int']>>;
  setting?: Maybe<Array<Scalars['String']>>;
};

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
}

export type UserTrialUsage = {
  __typename?: 'UserTrialUsage';
  product: Product;
  productId: Scalars['Int'];
  productCurriculum: ProductCurriculum;
  productCurriculumId: Scalars['Int'];
  active: Scalars['Boolean'];
  available: Scalars['Boolean'];
  dateExpiration?: Maybe<Scalars['DateTime']>;
};

export enum UserType {
  ADMINISTRATOR = 'ADMINISTRATOR',
  PRINCIPAL_VICE_PRINCIPAL = 'PRINCIPAL_VICE_PRINCIPAL',
  CURRICULUM = 'CURRICULUM',
  K5_TEACHER = 'K5_TEACHER',
  PREK_TEACHER = 'PREK_TEACHER',
  TECHNOLOGY_MEDIA = 'TECHNOLOGY_MEDIA',
  OCCUPATIONAL_THERAPIST = 'OCCUPATIONAL_THERAPIST',
  SPECIAL_EDUCATION = 'SPECIAL_EDUCATION',
  PARENT_FAMILY = 'PARENT_FAMILY',
  HOMESCHOOL_EDUCATOR = 'HOMESCHOOL_EDUCATOR',
  ESL_ESOL = 'ESL_ESOL',
  OTHER = 'OTHER',
  READING_SPECIALIST = 'READING_SPECIALIST',
}

export type UserUpdateInput = {
  externalId?: Maybe<ExternalIdUpdateInput>;
  sisId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  type?: Maybe<UserType>;
  pin?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  status?: Maybe<UserStatus>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
  organizationAssociations?: Maybe<Array<UserOrganizationInput>>;
};

export type UserWhereInput = {
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<ExternalIdInput>;
  username?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
};

export type UsersOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<UserOrderField>;
};

export type UsersUpdateInput = {
  status?: Maybe<UserStatus>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type UsersWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  firstName?: Maybe<Array<Scalars['String']>>;
  firstName_contains?: Maybe<Scalars['String']>;
  lastName?: Maybe<Array<Scalars['String']>>;
  lastName_contains?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  organizations?: Maybe<OrganizationsWhereInput>;
  organizationRoles?: Maybe<OrganizationRolesWhereInput>;
  pin?: Maybe<Array<Scalars['String']>>;
  username?: Maybe<Array<Scalars['String']>>;
  username_contains?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Array<Scalars['String']>>;
  sourceKind?: Maybe<Array<SourceKind>>;
  sisId?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Array<UserStatus>>;
  type?: Maybe<Array<UserType>>;
  includeRemoved?: Maybe<Scalars['Boolean']>;
  removed?: Maybe<Scalars['Boolean']>;
  AND?: Maybe<Array<UsersWhereInput>>;
  OR?: Maybe<Array<UsersWhereInput>>;
};

export type WetDryTryActivity = LiteRouteActivity & {
  __typename?: 'WetDryTryActivity';
  id: Scalars['Int'];
  activityTypeId: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  bookId: Scalars['Int'];
  url: Scalars['String'];
  book?: Maybe<Book>;
  activityType?: Maybe<ActivityType>;
};

export type WordInput = {
  wordId: Scalars['Int'];
  description: Scalars['String'];
};
